<script>
import { menuItems } from "../../../../../website-views/default-menu";
import simplebar from "simplebar-vue";
import i18n from "../../../../../websitei18n";
import Login from "../../../../../website-views/account/onpageLogin";
import Register from "../../../../../website-views/account/onpageRegistration";
import { EventBus } from '../../../../../website-app'
import PageLayoutProcessor from "./PageLayoutProcessor";


export default {
  name: 'WebsiteMenus',
  components: {
    simplebar,
    Login,
    Register,
    PageLayoutProcessor
  },
  data() {
    return {
      itemHovered: '',
      currencykey: process.env.MIX_CURRENCY_CONVERTER,
      conversion_rates: '',
      menuItemsRaw: menuItems,
      menuItems: [],
      menuItemsSlice1: 0,
      menuItemsSlice2: 0,
      csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
      storageurl: 'https://'+this.company.nickname+'.s3.eu-west-2.amazonaws.com',
      languages: [
        {
          flag: "/images/flags/us.jpg",
          language: "en",
          title: "English",
        },
        {
          flag: "/images/flags/french.jpg",
          language: "fr",
          title: "French",
        },
        {
          flag: "/images/flags/spain.jpg",
          language: "es",
          title: "Spanish",
        },
        {
          flag: "/images/flags/chaina.png",
          language: "zh",
          title: "Chinese",
        },
        {
          flag: "/images/flags/arabic.png",
          language: "ar",
          title: "Arabic",
        },
      ],
      cart: {
        products: [],
        uid: '',
        id: '',
      },
      currency: '',
      currencyicon: 'bx bx-pound',
      currencytext: 'GBP',
      currencycode: 'GBP',
      cartname: '',
      currencyicon: 'bx bx-pound',
      currencytext: 'GBP',
      cartLoading: false,
      initiateCheckout: false,
      cartPanelData: [],
      cartPanel: false,
      showCart: false, 
      showSearch: false,
      lan: i18n.locale,
      text: null,
      flag: null,
      value: null,
      loadedLayouts: {},
      menuLoaded: false,
    };
  },
  props: {
    company: {
      type: Object
    },
    user: {
      type: Object
    },
    domain: {
      type: Object
    },
    content: {
      type: Array
    },
    elements: {
      type: Array
    },
    filters: {
      type: Object
    },
    styles: {
      type: Array
    },
    liveMode: {
      type: Boolean,
      default: false
    },
    currencies: {
      default: []
    }
  },
  created() {
    //this.cartname = this.company.nickname + this.company.uid.slice(0,4);
    this.getMenu(this.filters.menus.value);
    var session_cart = window.sessionStorage.getItem("websitecart");
    session_cart = JSON.parse(session_cart);
    if(session_cart == null){
      this.checkAndGetCart();
    }else{
      this.cart = session_cart;
    }
    if(this.content[this.filterStylesKey(this.content, 'layout')].layout == 'Layout 2'){
      this.menuItemsSlice1 = ((this.menuItems.length - 1) / 2).toFixed(0);
    }else{
      this.menuItemsSlice1 = this.menuItems.length - 1;
    }
    var currency = window.localStorage.getItem("currency");
    if(currency){
      var parsecurrency = JSON.parse(currency);
      
      this.currencycode = parsecurrency["currency_code"];
      this.currencytext = parsecurrency["currency_code"];
      if(parsecurrency["currency_code"] == 'USD'){
        this.currencyicon = 'bx bx-dollar';
      }
      if(parsecurrency["currency_code"] == 'EUR'){
        this.currencyicon = 'bx bx-euro';
      }
    }
  },
  watch:{
    '$attrs.content[*].layout'() {
      if(this.liveMode == true){
        if(this.content[this.filterStylesKey(this.content, 'layout')].layout == 'Layout 2'){
          this.menuItemsSlice1 = ((this.menuItems.length - 1) / 2).toFixed(0);
          this.menuItemsSlice2 = this.menuItems.length - 1;
        }else{
          this.menuItemsSlice1 = this.menuItems.length - 1;
        }
      }
    }
  },
  mounted() {
    //this.getMenu(this.filters.menus.value);
    //this.value = this.languages.find((x) => x.language === i18n.locale);
   // this.text = this.value.title;
    //this.flag = this.value.flag;
    let self = this;
    EventBus.$on('add-to-cart', function(product, qty, variants, combination){
      //console.log('Cart Event Triggered');
       self.addToCart(product, qty, variants, combination);
    });

    if(this.content[this.filterStylesKey(this.content, 'layout')].layout == 'Layout 2'){
        this.menuItemsSlice1 = ((this.menuItems.length - 1) / 2).toFixed(0);
        this.menuItemsSlice2 = this.menuItems.length - 1;
      }else{
        this.menuItemsSlice1 = this.menuItems.length - 1;
      }
  },
  methods: {
    constructLink(link){
      if(link.includes('http') == true){
         return link;
      }else if(link.startsWith('/') == true){
          return link;
      }else if(link.startsWith('/') == false){
          return '/' + link;
      }
    },
    compileElementStyles(fieldname, types){
        var style = 'will-change: auto; ';
        if(types.includes('background') == true){
          if(fieldname !== 'column'){
              style += 'background-color:'+this.content[this.filterStylesKey(this.content, fieldname+'_colour')][fieldname+'_colour'].value+' !important;'
            }else{
              style += 'background-color:'+this.content[this.filterStylesKey(this.content, fieldname)][fieldname].subfields[this.filterStylesKey(this.content[this.filterStylesKey(this.content, fieldname)][fieldname].subfields, 'background_colour')].background_colour.value+' !important;'
            }
        }
        if(types.includes('color') == true){
          if(fieldname !== 'column'){
            style += 'color:'+this.content[this.filterStylesKey(this.content, fieldname+'_text_colour')][fieldname+'_text_colour'].value+' !important;'
          }else{
            style += 'color:'+this.content[this.filterStylesKey(this.content, fieldname)][fieldname].subfields[this.filterStylesKey(this.content[this.filterStylesKey(this.content, fieldname)][fieldname].subfields, 'text_colour')].text_colour.value+' !important;'
          }
        }
        if(types.includes('border') == true){
          if(fieldname !== 'column'){
            style += 'border-radius:'+this.content[this.filterStylesKey(this.content, fieldname+'_border_radius')][fieldname+'_border_radius'].top_left+this.content[this.filterStylesKey(this.content, fieldname+'_border_radius')][fieldname+'_border_radius'].units +' '+this.content[this.filterStylesKey(this.content, fieldname+'_border_radius')][fieldname+'_border_radius'].top_right+this.content[this.filterStylesKey(this.content, fieldname+'_border_radius')][fieldname+'_border_radius'].units +' '+this.content[this.filterStylesKey(this.content, fieldname+'_border_radius')][fieldname+'_border_radius'].bottom_right+this.content[this.filterStylesKey(this.content, fieldname+'_border_radius')][fieldname+'_border_radius'].units +' '+this.content[this.filterStylesKey(this.content, fieldname+'_border_radius')][fieldname+'_border_radius'].bottom_left+this.content[this.filterStylesKey(this.content, fieldname+'_border_radius')][fieldname+'_border_radius'].units +' !important;'
            style += ' border-left:'+this.content[this.filterStylesKey(this.content, fieldname+'_border')][fieldname+'_border'].left+'px !important; border-right: '+this.content[this.filterStylesKey(this.content, fieldname+'_border')][fieldname+'_border'].right+'px !important; border-top: '+this.content[this.filterStylesKey(this.content, fieldname+'_border')][fieldname+'_border'].top+'px !important; border-bottom: '+this.content[this.filterStylesKey(this.content, fieldname+'_border')][fieldname+'_border'].bottom+'px !important; ';
            style += 'border-style: '+this.content[this.filterStylesKey(this.content, fieldname+'_border_style')][fieldname+'_border_style'].value+' !important; ';
            style +=  ' border-color: '+this.content[this.filterStylesKey(this.content, fieldname+'_border_colour')][fieldname+'_border_colour'].value+' !important;' ;
          }else{
            style +=  'border-color: '+this.content[this.filterStylesKey(this.content, fieldname)][fieldname].subfields[this.filterStylesKey(this.content[this.filterStylesKey(this.content, fieldname)][fieldname].subfields, 'border_colour')].border_colour.value+' !important;'

            style += 'border-style:'+this.content[this.filterStylesKey(this.content, fieldname)][fieldname].subfields[this.filterStylesKey(this.content[this.filterStylesKey(this.content, fieldname)][fieldname].subfields, 'border_style')].border_style.value+' !important;'

            style += 'border-radius:'+this.content[this.filterStylesKey(this.content, fieldname)][fieldname].subfields[this.filterStylesKey(this.content[this.filterStylesKey(this.content, fieldname)][fieldname].subfields, 'border_radius')].border_radius.top_left+' '+this.content[this.filterStylesKey(this.content, fieldname)][fieldname].subfields[this.filterStylesKey(this.content[this.filterStylesKey(this.content, fieldname)][fieldname].subfields, 'border_radius')].border_radius.top_right+' '+this.content[this.filterStylesKey(this.content, fieldname)][fieldname].subfields[this.filterStylesKey(this.content[this.filterStylesKey(this.content, fieldname)][fieldname].subfields, 'border_radius')].border_radius.bottom_right+' '+this.content[this.filterStylesKey(this.content, fieldname)][fieldname].subfields[this.filterStylesKey(this.content[this.filterStylesKey(this.content, fieldname)][fieldname].subfields, 'border_radius')].border_radius.bottom_left+' !important;'
            style += 'border-left:'+this.content[this.filterStylesKey(this.content, fieldname)][fieldname].subfields[this.filterStylesKey(this.content[this.filterStylesKey(this.content, fieldname)][fieldname].subfields, 'border')].border.left+'px !important; border-right: '+this.content[this.filterStylesKey(this.content, fieldname)][fieldname].subfields[this.filterStylesKey(this.content[this.filterStylesKey(this.content, fieldname)][fieldname].subfields, 'border')].border.right+'px !important; border-top: '+this.content[this.filterStylesKey(this.content, fieldname)][fieldname].subfields[this.filterStylesKey(this.content[this.filterStylesKey(this.content, fieldname)][fieldname].subfields, 'border')].border.top+'px !important; border-bottom: '+this.content[this.filterStylesKey(this.content, fieldname)][fieldname].subfields[this.filterStylesKey(this.content[this.filterStylesKey(this.content, fieldname)][fieldname].subfields, 'border')].border.bottom+'px !important;'
          }

        }
        if(types.includes('margin') == true){
          if(fieldname !== 'column'){
          style +=  'margin-left:'+this.content[this.filterStylesKey(this.content, fieldname+'_margin')][fieldname+'_margin'].left+'px !important;';
          style +=  'margin-right: '+this.content[this.filterStylesKey(this.content, fieldname+'_margin')][fieldname+'_margin'].right+'px !important;';
          style +=  'margin-top: '+this.content[this.filterStylesKey(this.content, fieldname+'_margin')][fieldname+'_margin'].top+'px !important;';
          style +=  'margin-bottom: '+this.content[this.filterStylesKey(this.content, fieldname+'_margin')][fieldname+'_margin'].bottom+'px !important;';
          }else{
          style +=  'margin-left:'+this.content[this.filterStylesKey(this.content, fieldname)][fieldname].subfields[this.filterStylesKey(this.content[this.filterStylesKey(this.content, fieldname)][fieldname].subfields, 'margin')]['margin'].left+'px !important;'
          style +=  'margin-right: '+this.content[this.filterStylesKey(this.content, fieldname)][fieldname].subfields[this.filterStylesKey(this.content[this.filterStylesKey(this.content, fieldname)][fieldname].subfields, 'margin')]['margin'].right+'px !important;'
          style +=  'margin-top: '+this.content[this.filterStylesKey(this.content, fieldname)][fieldname].subfields[this.filterStylesKey(this.content[this.filterStylesKey(this.content, fieldname)][fieldname].subfields, 'margin')]['margin'].top+'px !important;'
          style +=  'margin-bottom: '+this.content[this.filterStylesKey(this.content, fieldname)][fieldname].subfields[this.filterStylesKey(this.content[this.filterStylesKey(this.content, fieldname)][fieldname].subfields, 'margin')]['margin'].bottom+'px !important;'
          }
        }
        if(types.includes('padding') == true){
          if(fieldname !== 'column'){
          style +=  'padding-left:'+this.content[this.filterStylesKey(this.content, fieldname+'_padding')][fieldname+'_padding'].left+'px !important;'
          style +=  'padding-right: '+this.content[this.filterStylesKey(this.content, fieldname+'_padding')][fieldname+'_padding'].right+'px !important;'
          style +=  'padding-top: '+this.content[this.filterStylesKey(this.content, fieldname+'_padding')][fieldname+'_padding'].top+'px !important;'
          style +=  'padding-bottom: '+this.content[this.filterStylesKey(this.content, fieldname+'_padding')][fieldname+'_padding'].bottom+'px !important;'
          }else{
            style +=  'padding-left:'+this.content[this.filterStylesKey(this.content, fieldname)][fieldname].subfields[this.filterStylesKey(this.content[this.filterStylesKey(this.content, fieldname)][fieldname].subfields, 'padding')]['padding'].left+'px !important;'
          style +=  'padding-right: '+this.content[this.filterStylesKey(this.content, fieldname)][fieldname].subfields[this.filterStylesKey(this.content[this.filterStylesKey(this.content, fieldname)][fieldname].subfields, 'padding')]['padding'].right+'px !important;'
          style +=  'padding-top: '+this.content[this.filterStylesKey(this.content, fieldname)][fieldname].subfields[this.filterStylesKey(this.content[this.filterStylesKey(this.content, fieldname)][fieldname].subfields, 'padding')]['padding'].top+'px !important;'
          style +=  'padding-bottom: '+this.content[this.filterStylesKey(this.content, fieldname)][fieldname].subfields[this.filterStylesKey(this.content[this.filterStylesKey(this.content, fieldname)][fieldname].subfields, 'padding')]['padding'].bottom+'px !important;'
          }
        }
        if(types.includes('size') == true){
          if(fieldname !== 'column'){
          style +=  'height:'+this.content[this.filterStylesKey(this.content, fieldname+'_height')][fieldname+'_height'].value+this.content[this.filterStylesKey(this.content, fieldname+'_height')][fieldname+'_height'].units+' !important;';
          style +=  'max-height:'+this.content[this.filterStylesKey(this.content, fieldname+'_max_height')][fieldname+'_max_height'].value+this.content[this.filterStylesKey(this.content, fieldname+'_max_height')][fieldname+'_max_height'].units+' !important;';
          style +=  'width:'+this.content[this.filterStylesKey(this.content, fieldname+'_width')][fieldname+'_width'].value+this.content[this.filterStylesKey(this.content, fieldname+'_width')][fieldname+'_width'].units+' !important;'
          style +=  'max-width:'+this.content[this.filterStylesKey(this.content, fieldname+'_max_width')][fieldname+'_max_width'].value+this.content[this.filterStylesKey(this.content, fieldname+'_max_width')][fieldname+'_max_width'].units+' !important;'
          }else{
          style +=  'height:'+this.content[this.filterStylesKey(this.content, fieldname)][fieldname].subfields[this.filterStylesKey(this.content[this.filterStylesKey(this.content, fieldname)][fieldname].subfields, 'height')]['height'].value+this.content[this.filterStylesKey(this.content, fieldname)][fieldname].subfields[this.filterStylesKey(this.content[this.filterStylesKey(this.content, fieldname)][fieldname].subfields, 'height')]['height'].units+' !important;';
          style +=  'max-height:'+this.content[this.filterStylesKey(this.content, fieldname)][fieldname].subfields[this.filterStylesKey(this.content[this.filterStylesKey(this.content, fieldname)][fieldname].subfields, 'max_height')]['max_height'].value+this.content[this.filterStylesKey(this.content, fieldname)][fieldname].subfields[this.filterStylesKey(this.content[this.filterStylesKey(this.content, fieldname)][fieldname].subfields, 'max_height')]['max_height'].units+' !important;';
          style +=  'width:'+this.content[this.filterStylesKey(this.content, fieldname)][fieldname].subfields[this.filterStylesKey(this.content[this.filterStylesKey(this.content, fieldname)][fieldname].subfields, 'width')]['width'].value+this.content[this.filterStylesKey(this.content, fieldname)][fieldname].subfields[this.filterStylesKey(this.content[this.filterStylesKey(this.content, fieldname)][fieldname].subfields, 'width')]['width'].units+' !important;'
          style +=  'max-width:'+this.content[this.filterStylesKey(this.content, fieldname)][fieldname].subfields[this.filterStylesKey(this.content[this.filterStylesKey(this.content, fieldname)][fieldname].subfields, 'max_width')]['max_width'].value+this.content[this.filterStylesKey(this.content, fieldname)][fieldname].subfields[this.filterStylesKey(this.content[this.filterStylesKey(this.content, fieldname)][fieldname].subfields, 'max_width')]['max_width'].units+' !important;'
          } 
        }
        
        if(types.includes('text') == true){
          style += 'font-family: \"'+this.content[this.filterStylesKey(this.content, fieldname)][fieldname].subfields[this.filterStylesKey(this.content[this.filterStylesKey(this.content, fieldname)][fieldname].subfields, 'font_family')].font_family.value.family+'\", '+this.content[this.filterStylesKey(this.content, fieldname)][fieldname].subfields[this.filterStylesKey(this.content[this.filterStylesKey(this.content, fieldname)][fieldname].subfields, 'font_family')].font_family.value.category+' !important; font-size:'+this.content[this.filterStylesKey(this.content, fieldname)][fieldname].subfields[this.filterStylesKey(this.content[this.filterStylesKey(this.content, fieldname)][fieldname].subfields, 'font_size')].font_size.value+this.content[this.filterStylesKey(this.content, fieldname)][fieldname].subfields[this.filterStylesKey(this.content[this.filterStylesKey(this.content, fieldname)][fieldname].subfields, 'font_size')].font_size.units+' !important; text-transform: '+this.content[this.filterStylesKey(this.content, fieldname)][fieldname].subfields[this.filterStylesKey(this.content[this.filterStylesKey(this.content, fieldname)][fieldname].subfields, 'text_transform')].text_transform.value+'!important;';

              
        }

        if(types.includes('box-shadow') == true){
          style += 'box-shadow: '+this.content[this.filterStylesKey(this.content, fieldname+'_box_shadow')][fieldname+'_box_shadow'].subfields[this.filterStylesKey(this.content[this.filterStylesKey(this.content, fieldname+'_box_shadow')][fieldname+'_box_shadow'].subfields, 'horizontal')].horizontal.value+''+this.content[this.filterStylesKey(this.content, fieldname+'_box_shadow')][fieldname+'_box_shadow'].subfields[this.filterStylesKey(this.content[this.filterStylesKey(this.content, fieldname+'_box_shadow')][fieldname+'_box_shadow'].subfields, 'horizontal')].horizontal.units+ ' ' + this.content[this.filterStylesKey(this.content, fieldname+'_box_shadow')][fieldname+'_box_shadow'].subfields[this.filterStylesKey(this.content[this.filterStylesKey(this.content, fieldname+'_box_shadow')][fieldname+'_box_shadow'].subfields, 'vertical')].vertical.value+''+this.content[this.filterStylesKey(this.content, fieldname+'_box_shadow')][fieldname+'_box_shadow'].subfields[this.filterStylesKey(this.content[this.filterStylesKey(this.content, fieldname+'_box_shadow')][fieldname+'_box_shadow'].subfields, 'vertical')].vertical.units+ ' ' +this.content[this.filterStylesKey(this.content, fieldname+'_box_shadow')][fieldname+'_box_shadow'].subfields[this.filterStylesKey(this.content[this.filterStylesKey(this.content, fieldname+'_box_shadow')][fieldname+'_box_shadow'].subfields, 'blur')].blur.value+''+this.content[this.filterStylesKey(this.content, fieldname+'_box_shadow')][fieldname+'_box_shadow'].subfields[this.filterStylesKey(this.content[this.filterStylesKey(this.content, fieldname+'_box_shadow')][fieldname+'_box_shadow'].subfields, 'blur')].blur.units+ ' ' +this.content[this.filterStylesKey(this.content, fieldname+'_box_shadow')][fieldname+'_box_shadow'].subfields[this.filterStylesKey(this.content[this.filterStylesKey(this.content, fieldname+'_box_shadow')][fieldname+'_box_shadow'].subfields, 'spread')].spread.value+''+this.content[this.filterStylesKey(this.content, fieldname+'_box_shadow')][fieldname+'_box_shadow'].subfields[this.filterStylesKey(this.content[this.filterStylesKey(this.content, fieldname+'_box_shadow')][fieldname+'_box_shadow'].subfields, 'spread')].spread.units+ ' '+ this.hexToRgb(this.content[this.filterStylesKey(this.content, fieldname+'_box_shadow')][fieldname+'_box_shadow'].subfields[this.filterStylesKey(this.content[this.filterStylesKey(this.content, fieldname+'_box_shadow')][fieldname+'_box_shadow'].subfields, 'color')].color.value, (this.content[this.filterStylesKey(this.content, fieldname+'_box_shadow')][fieldname+'_box_shadow'].subfields[this.filterStylesKey(this.content[this.filterStylesKey(this.content, fieldname+'_box_shadow')][fieldname+'_box_shadow'].subfields, 'opacity')].opacity.value !== null ? this.content[this.filterStylesKey(this.content, fieldname+'_box_shadow')][fieldname+'_box_shadow'].subfields[this.filterStylesKey(this.content[this.filterStylesKey(this.content, fieldname+'_box_shadow')][fieldname+'_box_shadow'].subfields, 'opacity')].opacity.value : 0.3)) + ' !important; ';
        }

        if((types.includes('text') == false) && (types.includes('text_alignment') == true)){
          style += ' text-align: '+this.content[this.filterStylesKey(this.content, 'text_align')]['text_align'].value+' !important;'
        }

        if((types.includes('text') == true) && types.includes('text_alignment') == true){
            style += ' text-align: '+this.content[this.filterStylesKey(this.content, fieldname)][fieldname].subfields[this.filterStylesKey(this.content[this.filterStylesKey(this.content, fieldname)][fieldname].subfields, fieldname+'_text_alignment')][fieldname+'_text_alignment'].value+' !important;'
          }

        return style;
      },
    getMenu(uid){

      var Storedmenu = window.sessionStorage.getItem(this.company.nickname+'-webmenu');
      if(Storedmenu && (Storedmenu !== 'undefined')){
        this.menuItems = JSON.parse(Storedmenu);
        this.menuLoaded = true;
        this.getLayouts();
      }


      if(this.menuLoaded == false){
        if(this.liveMode == true){
          axios.get('/website-api/widget/menu/'+uid).then(response => {
            this.menuItems = response.data.menuitems;
            this.menuLoaded = true;
            EventBus.$emit('menu-loaded');
             window.sessionStorage.setItem(this.company.nickname+'-webmenu', JSON.stringify(response.data.menuitems));
            return this.getLayouts();
          }).catch(error => {
            this.menuItems = this.menuItemsRaw;
            EventBus.$emit('menu-loaded');
          });
        }else{
          axios.get('/api/company/web/menu/'+uid, {headers: {'Authorization' : 'Bearer '+this.user.api_token}}).then(response => {
            this.menuItems = response.data.menuitems;
            EventBus.$emit('menu-loaded');
          }).catch(error => {
            this.menuItems = this.menuItemsRaw;
            EventBus.$emit('menu-loaded');
          });
        }
      }
    },
    onMenuClick(event) {
      event.preventDefault();
      const nextEl = event.target.nextElementSibling;
      if (nextEl && !nextEl.classList.contains("show")) {
        const parentEl = event.target.parentNode;
        if (parentEl) {
          parentEl.classList.remove("show");
        }
        nextEl.classList.add("show");
      } else if (nextEl) {
        nextEl.classList.remove("show");
      }
      return false;
    },
    /*onMenuHover(event) {
      event.preventDefault();
      const nextEl = event.target.nextElementSibling;
      if (nextEl && !nextEl.classList.contains("show")) {
        const parentEl = event.target.parentNode;
        if (parentEl) {
          parentEl.classList.remove("show");
        }
        nextEl.classList.add("show");
      } else if (nextEl) {
        nextEl.classList.remove("show");
      }
      return false;
    },*/
    onMenuHover(hoveredItem){
      this.itemHovered = hoveredItem;
    },
    filterStylesKey(styles, key){
            for(var i = 0; i < styles.length; i++){
               var keys = Object.keys(styles[i])
               if(keys.includes(key)){
                 return i;
               }
            }
          },
    /**
     * Returns true or false if given menu item has child or not
     * @param item menuItem
     */
    hasItems(item) {
      return item.menuitems !== undefined ? item.menuitems.length > 0 : false;
    },
    hasMegamenu(item){
      return item.menuitems.findIndex(item => item.resource == 'megamenu') > -1 ? true : false;
    },
    isMegamenu(item){
      return item.resource == 'megamenu' ? true : false;
    },
    topbarLight() {
      document.body.setAttribute("data-topbar", "light");
      document.body.removeAttribute("data-layout-size", "boxed");
    },
    boxedWidth() {
      document.body.setAttribute("data-layout-size", "boxed");
      document.body.removeAttribute("data-topbar", "light");
      document.body.setAttribute("data-topbar", "dark");
    },
    coloredHeader() {
      document.body.setAttribute("data-topbar", "colored");
      document.body.removeAttribute("data-layout-size", "boxed");
    },
    checkAndGetCart(){
      axios.get('/website-api/cart/read?cart_uid='+this.cart.uid, {headers: {
                  'Authorization': 'Bearer ' + this.user.api_token
              }}).then(response => {
        //console.log(response);
          if(response.data !== 0){
            this.cart = response.data;
            window.sessionStorage.setItem("websitecart", JSON.stringify(response.data));
          }else{
            window.sessionStorage.setItem("websitecart", JSON.stringify(this.cart))
          }
        
      }).catch(error => {
        this.error_reponse = error.response.data.errors;
      });
    },
    cartTotal(cart){
          var score = 0;
          if(cart.products.length > 1){
            for(var i = 0; i < cart.products.length; i++){
              var itemscore = (parseFloat(cart.products[i].price_exc) * parseFloat(cart.products[i].quantity));
              score = score + itemscore;
            }
          }else{
            score = cart.products[0].price_exc * cart.products[0].quantity;
          }
          return (score).toFixed(2);
        },
    addToCart(productdata, qty, variantsdata, combinationdata){
      this.cartLoading = true;
      if(this.cart.uid == ''){
        this.cart.products.push({product: productdata});
        this.createCart(productdata);
      }else{
        axios.post('/website-api/cart/'+this.cart.uid+'/add-product', {product: productdata, quantity: qty, variants: variantsdata, combination: combinationdata}, {headers: {
                  'Authorization': 'Bearer ' + this.user.api_token
              }}).then(response => {
        var carindex = this.cart.products.findIndex(item => item.product_id == productdata.id);
            if(carindex !== -1){
              this.cart.products[carindex] = response.data;
              this.cart.products[carindex]["product"] = productdata;
              window.sessionStorage.setItem("websitecart", JSON.stringify(this.cart));
              this.productAdded(productdata);
            }else if(carindex == -1){
              this.cart["products"].push(response.data);
              this.cart["products"][(this.cart.products.length - 1)]["product"] = productdata;
              window.sessionStorage.setItem("websitecart", JSON.stringify(this.cart));
              this.productAdded(productdata);
            }
      }).catch(error => {
        this.error_reponse = error.response.data.errors;
      });
      } 
    },
    removeProduct(id, index){
      axios.post('/website-api/cart/product/'+id+'/delete', {headers: {
                  'Authorization': 'Bearer ' + this.user.api_token
              }}).then(response => {
          this.cart.products.splice(index, 1);
          if(this.cart.length == 0){
            window.sessionStorage.deleteItem("websitecart");
            //this.checkAndGetCart();
          }else{
            window.sessionStorage.setItem("websitecart", JSON.stringify(this.cart));
          }
        }).catch(error => {
          this.error_reponse = error.response.data.errors;
        });
    },
    productAdded(product){
      //this.cartPanelData = product;
      //this.cartPanel = true;
      this.cartLoading = false;
      this.$refs.cart.show(true);
    },
    createCart(product){
      var token = '';
      if(this.user !== ''){
        token = this.user.api_token;
      }
      axios.post('/website-api/cart/create', product, {headers: {
                  'Authorization': 'Bearer ' + token
              }}).then(response => {
        this.cart = response.data[0];
        this.cart["products"] = [];
        this.cart.products.push(response.data[1]);
        this.cart.products[0]["product"] = product;
        window.sessionStorage.setItem("websitecart", JSON.stringify(this.cart));
        this.productAdded(product);
      }).catch(error => {

      });
    },
    toggleRightSidebar() {
      this.$parent.toggleRightSidebar();
    },
    toggleMenu() {
      let element = document.getElementById("topnav-menu-content");
      element.classList.toggle("show");

      let closebtn = document.getElementById("toggleClose");
      closebtn.classList.toggle("d-none");
    },
 
    convertCurrency(from, to, symbol){
        axios.get('https://api.freecurrencyapi.com/v1/latest?apikey='+this.currencykey+'&currencies=EUR,USD,GBP&base_currency='+from+'').then(response => {
          this.conversion_rates = response.data;
          //$emit('currency-updated', symbol, from, response.data);
          EventBus.$emit('currency-updated', symbol, from, response.data);
        }).catch(error => {

        });
    },
    updateCurrency(symbol, old_currency, new_currency){
          //EventBus.$emit('currency-updated', old_currency, new_currency);
          this.convertCurrency(new_currency, null, symbol);
        },
     setCurrency(code, title, currencyicon, symbol, currency) {
      this.updateCurrency(symbol, this.currencycode, code);
      this.currencycode = code;
      this.currencytext = code;
      this.currencyicon = currencyicon;
      //i18n.locale = locale;

      localStorage.setItem("currency", currency);
    },
    setLanguage(locale, country, flag) {
      this.lan = locale;
      this.text = country;
      this.flag = flag;
      i18n.locale = locale;
      localStorage.setItem("locale", locale);
    },
    goToCheckout(){
      if(this.$route.path == ('order' || '/order')){
        this.$router.go(0);
      }
    },
    getLayouts(){
      var subitems = this.menuItems.filter(menuItem => menuItem.menuitems.some(subitem => subitem.resource == 'megamenu')).flatMap(menuItem => menuItem.menuitems.filter(subitem => subitem.resource == 'megamenu'));
      this.compileLayouts(subitems);
      window.sessionStorage.setItem(this.company.nickname+'-menu-layouts', JSON.stringify(this.loadedLayouts));
    },
    compileLayouts(subitems){
      for(var i = 0; subitems.length > i; i++){
       this.getLayout(subitems[i].resource_id);
      }
    },
    async getLayout(uid){
      if(uid == null){
        var layout = [];
        layout["content"] = {"xl": [], "lg": [], "md": [], "sm": [], "xs": []};
        return  layout;
      }else if(!Object.keys(this.loadedLayouts).includes(uid)){
        await axios.get('/website-api/layout/'+uid, {headers: {
                  'Authorization': 'Bearer ' + this.user.api_token
              }}).then(response => {
                //this.loadedLayouts[uid] = response.data;
                return this.compileLoadedLayouts(uid, response.data);
              }).catch(error => {
                return 'could not load menu';
              });
      }else{
        return this.loadedLayouts[uid];
      }
    },
    compileLoadedLayouts(uid, response){
      this.loadedLayouts[uid] = response;
    }
  },
};
</script>

<template>
  <header v-if="content[filterStylesKey(content, 'layout')].layout.value == 'Layout 1'" id="pb-menu-layout-1" class="shadow-none">
    <div class="navbar-header" :class="{'bg-dark' : content[filterStylesKey(content, 'layout_colour')].layout_colour.value == 'Dark'}">
      <div class="d-flex w-25" v-if="content[filterStylesKey(content, 'logo_position')].logo_position.value == 'logo center'" >

        <b-dropdown
          v-if="(elements[filterStylesKey(elements, 'show_search')].show_search.value == true)"
          class="d-inline-block d-lg-none ml-2"
          variant="black"
          menu-class="dropdown-menu-lg p-0 dropdown-menu-end cart-dropdown"
          :menu-class="{'bg-dark' : content[filterStylesKey(content, 'layout_colour')].layout_colour.value == 'Dark'}"
          toggle-class="header-item noti-icon"
          right
        >
          <template v-slot:button-content>
            <i class="mdi mdi-magnify"></i>
          </template>

          <form class="p-3">
            <div class="form-group m-0">
              <div class="input-group">
                <input
                  type="text"
                  class="form-control"
                  placeholder="Search ..."
                  aria-label="Recipient's username"
                />
                <div class="input-group-append">
                  <button class="btn btn-primary" type="submit">
                    <i class="mdi mdi-magnify"></i>
                  </button>
                </div>
              </div>
            </div>
          </form>
        </b-dropdown>

        <!--<b-dropdown variant="white" right toggle-class="header-item">
          <template v-slot:button-content>
            <img class :src="flag" alt="Header Language" height="16" />
            {{ text }}
          </template>
          <b-dropdown-item
            class="notify-item"
            v-for="(entry, i) in languages"
            :key="`Lang${i}`"
            :value="entry"
            @click="setLanguage(entry.language, entry.title, entry.flag)"
            :class="{ active: lan === entry.language }"
          >
            <img
              :src="`${entry.flag}`"
              alt="user-image"
              class="me-1"
              height="12"
            />
            <span class="align-middle">{{ entry.title }}</span>
          </b-dropdown-item>
        </b-dropdown>-->



        <!--<div class="dropdown d-none d-lg-inline-block ml-1">
          <button
            type="button"
            class="btn header-item noti-icon"
            @click="initFullScreen"
          >
            <i class="bx bx-fullscreen"></i>
          </button>
        </div>-->
        <div class="dropdown d-none d-lg-inline-block ml-1">
          <button  
            v-if="(elements[filterStylesKey(elements, 'show_search')].show_search.value == true)"
            type="button"
            class="btn header-item noti-icon"
            @click="showSearch = !showSearch"
          >
            <i class="bx bx-search" :class="{'text-white' : content[filterStylesKey(content, 'layout_colour')].layout_colour.value == 'Dark'}"></i>
          </button>
        </div>
        <b-dropdown
          v-if="elements[filterStylesKey(elements, 'show_currency')].show_currency.value == true"
          variant="white" right toggle-class="header-item noti-icon"
        >
          <template v-slot:button-content>
            <i :class="[`${currencyicon}`, {'text-white' : content[filterStylesKey(content, 'layout_colour')].layout_colour.value == 'Dark'}]" :alt="'Pay in ' + currency" ></i>
          </template>

           <b-dropdown-item
            class="notify-item"
            v-for="(entry, i) in currencies"
            :key="`Lang${i}`"
            :value="entry"
            @click="setCurrency(entry.code, entry.name, entry.icon, entry.symbol, entry)"
            :class=" {'active' : lan === entry.language}"
          >
            <i :class="`${entry.icon}`" :alt="'Pay in ' + entry.name" class="me-1" ></i>
            <span class="align-middle">{{ entry.name }}</span>
          </b-dropdown-item>
        </b-dropdown>

      </div>
      <div class="d-flex" :class="{'w-100' : content[filterStylesKey(content, 'logo_position')].logo_position.value == 'logo left', 'w-50' : content[filterStylesKey(content, 'logo_position')].logo_position.value == 'logo center'}">
        <!-- LOGO -->
        <div class="navbar-brand-box px-0 bg-transparent" :class="{'text-center mx-auto' : content[filterStylesKey(content, 'logo_position')].logo_position.value == 'logo center'}" v-if="content[filterStylesKey(content, 'logo_position')].logo_position.value !== 'logo right'">
          <a href="/" class="logo" >
            <span class="logo-sm">
              <img v-if="content[filterStylesKey(content, 'logo')].logo.value !== ''" :src="content[filterStylesKey(content, 'logo')].logo.value" :width="content[filterStylesKey(content, 'logo')].logo.width.value + content[filterStylesKey(content, 'logo')].logo.width.units" :height="content[filterStylesKey(content, 'logo')].logo.height.value + content[filterStylesKey(content, 'logo')].logo.height.units">
              <div v-else class="d-flex logo-text-holder"><span class="logo-text">{{company.name.slice(0, 1)}}</span></div>
            </span>
            <span class="logo-lg">
              <img v-if="content[filterStylesKey(content, 'logo')].logo.value !== ''" :src="content[filterStylesKey(content, 'logo')].logo.value" :width="content[filterStylesKey(content, 'logo')].logo.width.value + content[filterStylesKey(content, 'logo')].logo.width.units" :height="content[filterStylesKey(content, 'logo')].logo.height.value + content[filterStylesKey(content, 'logo')].logo.height.units">
              <div v-else class="d-flex logo-text-holder"><span class="logo-text" :class="{'text-dark' : content[filterStylesKey(content, 'layout_colour')].layout_colour.value == 'Light', 'text-white' : content[filterStylesKey(content, 'layout_colour')].layout_colour.value == 'Dark'}">{{company.name}}</span></div>
            </span>
          </a>

          
        </div>

        <button
          id="toggle"
          type="button"
          class="btn btn-sm me-2 font-size-16 d-lg-none header-item"
          @click="toggleMenu"
        >
          <i class="fa fa-fw fa-bars"></i>

        </button>
        <button
          id="toggleClose"
          type="button"
          class="btn btn-sm me-2 font-size-16 d-lg-none header-item d-none position-fixed top-0 right-0 mr-2"
          @click="toggleMenu"
        >

          <i class="fas fa-fw fa-times"></i>
        </button>
        
      </div>
      <transition name="fade-right">
         <form class="app-search d-none d-lg-block ml-auto w-50 my-auto" v-if="(showSearch == true) && (content[filterStylesKey(content, 'logo_position')].logo_position.value == 'logo left')" >
          <div class="position-relative">
            <input
              type="text"
              class="form-control bg-light bg-soft"
            
               :class="{'bg-dark' : content[filterStylesKey(content, 'layout_colour')].layout_colour.value == 'Dark', 'bg-light' : content[filterStylesKey(content, 'layout_colour')].layout_colour.value == 'Light'}"
            />
            <span class="bx bx-search-alt" :class="{'text-light' : content[filterStylesKey(content, 'layout_colour')].layout_colour.value == 'Dark'}" ></span>
          </div>
        </form>
      </transition>
      <transition name="fade-top">
         <form class="app-search d-none d-lg-block mx-auto w-50 my-auto position-absolute top-0 right-0 left-0" v-if="(showSearch == true) && ((content[filterStylesKey(content, 'logo_position')].logo_position.value == 'logo center') || (content[filterStylesKey(content, 'logo_position')].logo_position.value == 'logo right'))"  :class="{'bg-dark' : content[filterStylesKey(content, 'layout_colour')].layout_colour.value == 'Dark', 'bg-white' : content[filterStylesKey(content, 'layout_colour')].layout_colour.value == 'Light'}" >
          <div class="position-relative">
            <input
              type="text"
              class="form-control bg-light bg-soft"
             
               :class="{'bg-dark' : content[filterStylesKey(content, 'layout_colour')].layout_colour.value == 'Dark', 'bg-light' : content[filterStylesKey(content, 'layout_colour')].layout_colour.value == 'Light'}"
            />
            <span class="bx bx-search-alt" :class="{'text-light' : content[filterStylesKey(content, 'layout_colour')].layout_colour.value == 'Dark'}" ></span>
          </div>
        </form>
      </transition>
      <div class="d-flex"  :class="{'ml-auto' : content[filterStylesKey(content, 'logo_position')].logo_position.value == 'logo left', 'mr-auto' : content[filterStylesKey(content, 'logo_position')].logo_position.value == 'logo right', 'ml-auto w-25' : content[filterStylesKey(content, 'logo_position')].logo_position.value == 'logo center'}">
        <b-dropdown
          v-if="(elements[filterStylesKey(elements, 'show_search')].show_search.value == true) && (content[filterStylesKey(content, 'logo_position')].logo_position.value !== 'logo center')"
          class="d-inline-block d-lg-none ml-2"
          variant="black"
          menu-class="dropdown-menu-lg p-0 dropdown-menu-end"
          :menu-class="{'bg-dark' : content[filterStylesKey(content, 'layout_colour')].layout_colour.value == 'Dark'}"
          toggle-class="header-item noti-icon"
          right
        >
          <template v-slot:button-content>
            <i class="mdi mdi-magnify"></i>
          </template>

          <form class="p-3">
            <div class="form-group m-0">
              <div class="input-group">
                <input
                  type="text"
                  class="form-control"
                  placeholder="Search ..."
                  aria-label="Recipient's username"
                />
                <div class="input-group-append">
                  <button class="btn btn-primary" type="submit">
                    <i class="mdi mdi-magnify"></i>
                  </button>
                </div>
              </div>
            </div>
          </form>
        </b-dropdown>

        <!--<b-dropdown variant="white" right toggle-class="header-item">
          <template v-slot:button-content>
            <img class :src="flag" alt="Header Language" height="16" />
            {{ text }}
          </template>
          <b-dropdown-item
            class="notify-item"
            v-for="(entry, i) in languages"
            :key="`Lang${i}`"
            :value="entry"
            @click="setLanguage(entry.language, entry.title, entry.flag)"
            :class="{ active: lan === entry.language }"
          >
            <img
              :src="`${entry.flag}`"
              alt="user-image"
              class="me-1"
              height="12"
            />
            <span class="align-middle">{{ entry.title }}</span>
          </b-dropdown-item>
        </b-dropdown>-->



        <!--<div class="dropdown d-none d-lg-inline-block ml-1">
          <button
            type="button"
            class="btn header-item noti-icon"
            @click="initFullScreen"
          >
            <i class="bx bx-fullscreen"></i>
          </button>
        </div>-->
        <div class="dropdown d-none d-lg-inline-block ml-1">
          <button  
            v-if="(elements[filterStylesKey(elements, 'show_search')].show_search.value == true) && (content[filterStylesKey(content, 'logo_position')].logo_position.value !== 'logo center')"
            type="button"
            class="btn header-item noti-icon"
            @click="showSearch = !showSearch"
          >
            <i class="bx bx-search" :class="{'text-white' : content[filterStylesKey(content, 'layout_colour')].layout_colour.value == 'Dark'}"></i>
          </button>
        </div>
        <b-dropdown
          v-if="(content[filterStylesKey(content, 'logo_position')].logo_position.value !== 'logo center') && (elements[filterStylesKey(elements, 'show_currency')].show_currency.value == true)"
          variant="white" right toggle-class="header-item noti-icon"
        >
          <template v-slot:button-content>
            <i :class="[`${currencyicon}`, {'text-white' : content[filterStylesKey(content, 'layout_colour')].layout_colour.value == 'Dark'}]" :alt="'Pay in ' + currency" ></i>
          </template>

           <b-dropdown-item
            class="notify-item"
            v-for="(entry, i) in currencies"
            :key="`Lang${i}`"
            :value="entry"
            @click="setCurrency(entry.code, entry.name, entry.icon, entry.symbol, entry)"
            :class=" {'active' : lan === entry.language}"
          >
            <i :class="`${entry.icon}`" :alt="'Pay in ' + entry.name" class="me-1" ></i>
            <span class="align-middle">{{ entry.name }}</span>
          </b-dropdown-item>
        </b-dropdown>
        <b-dropdown
        v-if="elements[filterStylesKey(elements, 'show_cart')].show_cart.value == true"
          right
          class="cart-drop"
          menu-class="dropdown-menu-lg p-0 dropdown-menu-right cart-dropdown border-radius-1em"
          :menu-class="{'bg-dark' : content[filterStylesKey(content, 'layout_colour')].layout_colour.value == 'Dark'}"
          toggle-class="header-item noti-icon"
          variant="black"
          ref="cart"
          :class="{'ml-auto' : content[filterStylesKey(content, 'logo_position')].logo_position.value == 'logo center'}"
        >
          <template v-slot:button-content>
            <i class="bx bx-shopping-bag" :class="{'text-white' : content[filterStylesKey(content, 'layout_colour')].layout_colour.value == 'Dark'}"></i>
            <span
              class="badge bg-danger rounded-pill"
            >{{cart.products.length}}</span>
          </template>

          <div class="p-3">
            <div class="row align-items-center">
              <div class="col">
                <h6 class="m-0">Shopping Cart</h6>
              </div>
              <div class="col-auto">
                <a href="#" class="small">View Cart</a>
              </div>
            </div>
          </div>
          <simplebar style="max-height: 430px;">
          <b-list-group v-if="cartLoading == false">
            <b-list-group-item  v-for="(productitem, index) in cart.products" href="javascript: void(0);" class="text-reset notification-item px-0 py-3 m-0">
              <div class="media">
                <div class="avatar-sm me-3">
                  <img v-if="productitem.product.cover_image" :src="storageurl+productitem.product.cover_image.src.replaceAll('//', '/')" class="avatar-title rounded-circle">
                  <span v-else class="avatar-title bg-primary rounded-circle font-size-16" >
                    <i class="bx bx-cart"></i>
                  </span>
                </div>
                <div class="cart-name-cell my-auto w-50">
                  <h6 class="mt-0 mb-1 text-truncate">{{productitem.product.name}}</h6>
                </div>
                <div class="my-auto text-right d-flex flex-column mx-auto">
                  <a href="javascript:;" class="text-center" @click="productitem.quantity++"><i class="bx bx-chevron-up mb-auto mx-auto"></i></a>
                  <b-form-input type="number"  v-model="productitem.quantity" class="visible mx-auto my-auto d-none" style="width: 25%;" >
                  </b-form-input>
                  <span class="mx-auto my-auto">{{productitem.quantity}}</span>
                  <a v-if="productitem.quantity > 1" href="javascript:;" class="text-center" @click="productitem.quantity--"><i class="bx bx-chevron-down mt-auto mx-auto"></i></a>
                  <a v-else href="javascript:;" class="text-center" @click="removeProduct(productitem.id, index)"><i class="bx bx-chevron-down mt-auto mx-auto"></i></a>
                </div>
                <div class="my-auto text-center d-flex flex-column mx-auto">
                  <p class="mb-0"><span class="text-muted">£</span>{{productitem.price_exc}}</p>
                  <small>Item Price Exc</small>
                </div>
                <div class="my-auto text-center d-flex flex-column mx-auto">
                  <p class="mb-0"><span class="text-muted">£</span>{{(productitem.price_exc * productitem.quantity).toFixed(2)}}</p>
                  <small>Total Price Exc</small>
                </div>
                <div class="my-auto mx-auto text-center">
                 <a class="btn btn-outline-light btn-rounded" @click="removeProduct(productitem.id, index)"><i class="bx bx-trash-alt"></i></a>
                </div>
              </div>
            </b-list-group-item>
            <b-list-group-item v-if="cart.products.length == 0">
              <div class="p-5 text-center border">
                <i class="bx bx-shopping-bag font-size-42 text-secondary mb-2"></i>
                <h6>No Products in Cart</h6>
              </div>
            </b-list-group-item>
          </b-list-group>
            

          </simplebar>
          <b-overlay
            :show="cartLoading">
              <div class="p-4 border-top d-flex bg-light" v-if="(cart.products.length !== 0) && (cartLoading == false)">
                <strong class="mr-auto flex-grow-2"> Total: </strong>
                  <span class="mx-auto flex-grow-1 text-center"><strong class="text-primary mr-2">£</strong> {{cartTotal(cart)}}</span>
              </div>
          </b-overlay>
         <div class="p-2 border-top d-grid" v-if="cart.products.length !== 0">
            <router-link class="btn btn-sm btn-link font-size-14 text-center btn-primary text-white btn-rounded" :to="{ name: 'Order', params: { cart } }"  >
              <i class=" me-1"></i>
              <span key="t-view-more"> Checkout Now </span>
            </router-link>
          </div>
        </b-dropdown>
        <b-dropdown
        v-if="elements[filterStylesKey(elements, 'show_account')].show_account.value == true"
          right
          variant="black"
          toggle-class="header-item"
          menu-class="dropdown-menu-end"
          class="account-drop"
          :menu-class="{'border-radius-1em p-0 login-dropdown dropdown-menu-end' : !user, 'bg-dark text-white' : content[filterStylesKey(content, 'layout_colour')].layout_colour.value == 'Dark'}"
        >
          <template v-slot:button-content>
            <div v-if="user">
            <img
              v-if="user.avatar"
              class="rounded-circle header-profile-user"
              :src="user.avatar"
              alt="Header Avatar"
            />
            <img v-else
              class="rounded-circle header-profile-user"
              src="/images/product-placeholder.png"
            > 
            <span class="d-none d-xl-inline-block ml-1" :class="{'text-white' : content[filterStylesKey(content, 'layout_colour')].layout_colour.value == 'Dark'}">{{user.name}} {{user.lastname}}</span>
            <i class="mdi mdi-chevron-down d-none d-xl-inline-block"></i>
            </div>
            <div v-else>
              <img
              class="rounded-circle header-profile-user"
              src="/images/product-placeholder.png"
              alt="Sign in to Gemesys"
            />
            <span class="d-none d-xl-inline-block ml-1" :class="{'text-white' : content[filterStylesKey(content, 'layout_colour')].layout_colour.value == 'Dark'}">
              My Account
            </span>
            <i class="mdi mdi-chevron-down d-none d-xl-inline-block"></i>
            </div>

            
          </template>
          <!-- item-->
           <div v-if="user">
          <b-dropdown-item href="/account" :class="{'bg-dark text-white dropdown-item-white' : content[filterStylesKey(content, 'layout_colour')].layout_colour.value == 'Dark'}">
            <i class="bx bx-user font-size-16 align-middle me-1"></i>
            My Account
          </b-dropdown-item>
          <b-dropdown-item href="/account#addresses" :class="{'bg-dark text-white dropdown-item-white' : content[filterStylesKey(content, 'layout_colour')].layout_colour.value == 'Dark'}">
            <i class="bx bx-home-alt font-size-16 align-middle me-1"></i>
            Addresses
          </b-dropdown-item>
          <b-dropdown-item href="/account#orders" :class="{'bg-dark text-white dropdown-item-white' : content[filterStylesKey(content, 'layout_colour')].layout_colour.value == 'Dark'}">
            <i class="bx bx-tag font-size-16 align-middle me-1"></i>
            Orders
          </b-dropdown-item>
          <b-dropdown-item class="d-block"  href="/account#messages" :class="{'bg-dark text-white dropdown-item-white' : content[filterStylesKey(content, 'layout_colour')].layout_colour.value == 'Dark'}">
            <span class="badge bg-success float-end">11</span>
            <i class="bx bx-chat font-size-16 align-middle me-1"></i>
            Messages
          </b-dropdown-item>
          <b-dropdown-item  href="/account#wishlist" :class="{'bg-dark text-white dropdown-item-white' : content[filterStylesKey(content, 'layout_colour')].layout_colour.value == 'Dark'}">
            <i class="mdi mdi-heart-outline font-size-16 align-middle me-1"></i>
            Wishlist
          </b-dropdown-item>

          <b-dropdown-divider></b-dropdown-divider>
          <a href="/account/logout" class="dropdown-item text-danger">
            <i
              class="bx bx-power-off font-size-16 align-middle me-1 text-danger"
            ></i>
           Logout
          </a>
          </div>
          <div v-else class="p-0">
            <Login :submit-url="'http://website.'+domain.domain_key+'.gemesys.co.uk/account/login'" auth-error=""  @register="$bvModal.show('register')">
                 <input type="hidden" name="_token" :value="csrf">
            </Login>
          </div>
        </b-dropdown>
      
        <!--<div class="dropdown d-inline-block">
          <button
            type="button"
            class="btn header-item noti-icon right-bar-toggle toggle-right"
            @click="toggleRightSidebar"
          >
            <i class="bx bx-cog bx-spin toggle-right"></i>
          </button>
        </div>-->
      </div>
       <div class="navbar-brand-box px-0 bg-transparent" :class="{'text-right' : content[filterStylesKey(content, 'logo_position')].logo_position.value == 'logo right'}" v-if="(content[filterStylesKey(content, 'logo_position')].logo_position.value == 'logo right')">
          <a href="/" class="logo" >
            <span class="logo-sm">
              <img v-if="content[filterStylesKey(content, 'logo')].logo.value !== ''" :src="content[filterStylesKey(content, 'logo')].logo.value" :width="content[filterStylesKey(content, 'logo')].logo.width.value + content[filterStylesKey(content, 'logo')].logo.width.units" :height="content[filterStylesKey(content, 'logo')].logo.height.value + content[filterStylesKey(content, 'logo')].logo.height.units" >
              <div v-else class="d-flex logo-text-holder"><span class="logo-text">{{company.name.slice(0, 1)}}</span></div>
            </span>
            <span class="logo-lg">
              <img v-if="content[filterStylesKey(content, 'logo')].logo.value !== ''" :src="content[filterStylesKey(content, 'logo')].logo.value" :width="content[filterStylesKey(content, 'logo')].logo.width.value + content[filterStylesKey(content, 'logo')].logo.width.units" :height="content[filterStylesKey(content, 'logo')].logo.height.value + content[filterStylesKey(content, 'logo')].logo.height.units" >
              <div v-else class="d-flex logo-text-holder"><span class="logo-text" :class="{'text-dark' : content[filterStylesKey(content, 'layout_colour')].layout_colour.value == 'Light', 'text-white' : content[filterStylesKey(content, 'layout_colour')].layout_colour.value == 'Dark'}">{{company.name}}</span></div>
            </span>
          </a>

          
        </div>
    </div>
    <div class="border-top" :class="{'bg-dark' : content[filterStylesKey(content, 'layout_colour')].layout_colour.value == 'Dark', 'bg-white' : content[filterStylesKey(content, 'layout_colour')].layout_colour.value !== 'Dark'}">
    <div class="container-fluid">
      <nav class="navbar navbar-light navbar-expand-lg topnav-menu">
        <div id="topnav-menu-content" v-if="liveMode == true" class="justify-content-center collapse navbar-collapse">

          <ul class="navbar-nav">
            <!-- Menu data -->
           
            <template v-for="(item, index) of menuItems">
              <li class="nav-item dropdown" :key="index" @mouseleave="hasMegamenu(item) == false ? onMenuHover([]) : ''" :class="{'dropdown-mega' : hasMegamenu(item)}">
                <router-link
                  class="nav-link dropdown-toggle arrow-none"
                  v-if="!hasItems(item)"
                  id="topnav-components"
                  :to="constructLink(item.link)"
                  role="button"
                  :class="{'text-white' : content[filterStylesKey(content, 'layout_colour')].layout_colour.value == 'Dark'}"
                   :style="compileElementStyles('menu_text', ['text'])"

                >
                  <i :class="`bx ${item.icon} mr-2`"></i>{{ item.label }}
                  <div class="arrow-down" v-if="hasItems(item)"></div>
                </router-link>
                <!-- <b-dropdown v-else-if="hasMegamenu(item)"
                        variant="black"
                        class="dropdown-mega d-none d-lg-block"
                        toggle-class="nav-link lh-1"
                        menu-class="dropdown-megamenu dropdown-menu-end position-absolute w-100 left-0 right-0 p-3"
                        @mouseover="onMenuHover([index])"
                        :class="{'show' : itemHovered[0] == index}"
                      >
                        <template v-slot:button-content >
                          {{ item.label }}
                          <i class="mdi mdi-chevron-down"></i>
                        </template>

                        <b-row class="p-4">
                            Megamenu
                            
                        </b-row>
                    </b-dropdown>-->
                <a
                  v-else
                  class="nav-link dropdown-toggle arrow-none"
                  @click="onMenuClick($event)"
                  @mouseenter="onMenuHover([index])"
                  href="javascript: void(0);"
                  id="topnav-components"
                  role="button"
                  :class="{'text-white' : content[filterStylesKey(content, 'layout_colour')].layout_colour.value == 'Dark', 'dropdown-mega' : hasMegamenu(item)}"
                   :style="compileElementStyles('menu_text', ['text'])"
                >
                  <i :class="`bx ${item.icon} mr-1`"></i>
                  {{ item.label }}
                  <div class="arrow-down"></div>
                </a>

                <div
                  class="dropdown-menu m-w-100"
                  :class="{'bg-dark' : content[filterStylesKey(content, 'layout_colour')].layout_colour.value == 'Dark', 'show' : itemHovered[0] == index, 'left-0 right-0' : hasMegamenu(item)}"
                  aria-labelledby="topnav-dashboard"
                  v-if="hasItems(item) && (itemHovered[0] == index)"
                >
                  <template v-for="(subitem, subindex) of item.menuitems">
                    <b-row class="p-4" v-if="isMegamenu(subitem) == true" @mouseover="onMenuHover([index])" >
                            <PageLayoutProcessor v-if="Object.keys(loadedLayouts).includes(subitem.resource_id)" :sectionType="'menu'" class="megamenu-content"  :page="loadedLayouts[subitem.resource_id]['content']" :content="loadedLayouts[subitem.resource_id]['content'][$attrs.viewPortSize]" :company="domain.company" :user="user" :domain="domain" :exchange_rates="$attrs.exchange_rates"  :currencies="currencies" :selected_currency="$attrs.selected_currency" :selected_currency_symbol="$attrs.selected_currency_symbol" :viewPortSize="$attrs.viewPortSize" :windowInnerWidth="$attrs.windowInnerWidth" :resource="$attrs.resource" :loadingPage="$attrs.loadingPage" ></PageLayoutProcessor>
                            
                    </b-row>
                    <router-link
                      class="col dropdown-item side-nav-link-ref"
                      :class="{'text-white' : content[filterStylesKey(content, 'layout_colour')].layout_colour.value == 'Dark'}"
                       :style="compileElementStyles('dropdown_text', ['text'])"
                      :key="index"
                      v-else-if="!hasItems(subitem)"
                      :to="constructLink(subitem.link)"
                      >{{ subitem.label }}</router-link
                    >
                    
                    <div class="dropdown dropright" v-else :key="index">
                      <a
                        class="dropdown-item dropdown-toggle dropright d-flex"
                        href="javascript: void(0);"
                        :class="{'text-white' : content[filterStylesKey(content, 'layout_colour')].layout_colour.value == 'Dark'}"
                        @click="onMenuClick($event)"
                         @mouseover="onMenuHover([index, subindex])"
                         @mouseout="onMenuHover(null)"
                         :style="compileElementStyles('dropdown_text', ['text'])"
                        >{{ subitem.label }}
                        <div class="arrow-right d-inline-block"></div>
                      </a>
                      <div class="dropdown-menu dropright" :class="{'bg-dark' : content[filterStylesKey(content, 'layout_colour')].layout_colour.value == 'Dark', 'show' : (itemHovered[0] == index) && (itemHovered[1] == subindex)}">
                        <template
                          v-for="(subSubitem, subSubindex) of subitem.menuitems"
                        >
                          <router-link
                            class="dropdown-item side-nav-link-ref"
                            :key="index"
                            v-if="!hasItems(subSubitem)"
                            :to="constructLink(subSubitem.link)"
                            :class="{'text-white' : content[filterStylesKey(content, 'layout_colour')].layout_colour.value == 'Dark'}"
                            
                            >{{ subSubitem.label }}</router-link
                          >
                          <div
                            class="dropdown"
                            v-if="hasItems(subSubitem)"
                            :key="index"
                          >
                            <a
                              class="dropdown-item dropdown-toggle d-flex"
                              href="javascript: void(0);"
                              @click="onMenuClick($event)"
                               @mouseover="onMenuHover([index, subindex, subSubindex])"
                               @mouseout="onMenuHover(null)"
                              :class="{'text-white' : content[filterStylesKey(content, 'layout_colour')].layout_colour.value == 'Dark'}"
                              >{{ subSubitem.label }}
                              <div class="arrow-right"></div>
                            </a>
                            <div class="dropdown-menu dropright" :class="{'bg-dark' : content[filterStylesKey(content, 'layout_colour')].layout_colour.value == 'Dark', 'show' : (itemHovered[0] == index) && (itemHovered[1] == subindex) && (itemHovered[2] == subSubindex)}">
                              <template
                                v-for="(
                                  subSubSubitem, index
                                ) of subSubitem.menuitems"
                              >
                                <router-link
                                  class="dropdown-item side-nav-link-ref"
                                  :key="index"
                                  :to="constructLink(subSubSubitem.link)"
                                  routerLinkActive="active"
                                  >{{ subSubSubitem.label }}</router-link
                                >
                              </template>
                            </div>
                          </div>
                        </template>
                      </div>
                    </div>
                  </template>
                </div>
              </li>
            </template>
          </ul>
          <ul class="navbar-nav">
            <!-- Menu data -->

            <!--<template v-for="(item, index) of menuItems">
              <li class="nav-item dropdown" :key="index">
                <a
                  class="nav-link dropdown-toggle arrow-none"
                  v-if="!item.subItems && liveMode == false"
                  id="topnav-components"
                  :href="item.link"
                  role="button"
                  :class="{'text-white' : content[filterStylesKey(content, 'layout_colour')].layout_colour.value == 'Dark'}"
                >
                  <i :class="`bx ${item.icon} mr-2`"></i>{{ $t(item.label) }}
                  <div class="arrow-down" v-if="hasItems(item)"></div>
                </a>
                <router-link
                  class="nav-link dropdown-toggle arrow-none"
                  v-if="!item.subItems && liveMode == true"
                  id="topnav-components"
                  :to="item.link"
                  role="button"
                  :class="{'text-white' : content[filterStylesKey(content, 'layout_colour')].layout_colour.value == 'Dark'}"
                >
                  <i :class="`bx ${item.icon} mr-2`"></i>{{ $t(item.label) }}
                  <div class="arrow-down" v-if="hasItems(item)"></div>
                </router-link>

                <a
                  v-if="item.subItems"
                  class="nav-link dropdown-toggle arrow-none"
                  @click="onMenuClick($event)"
                   @mouseover="onMenuHover($event)"
                   @mouseout="onMenuHover(null)"
                  href="javascript: void(0);"
                  id="topnav-components"
                  role="button"
                  :class="{'text-white' : content[filterStylesKey(content, 'layout_colour')].layout_colour.value == 'Dark'}"
                >
                  <i :class="`bx ${item.icon} mr-1`"></i>
                  {{ $t(item.label) }}
                  <div class="arrow-down"></div>
                </a>

                <div

                  :class="{'bg-dark' : content[filterStylesKey(content, 'layout_colour')].layout_colour.value == 'Dark'}"
                  class="dropdown-menu"
                  aria-labelledby="topnav-dashboard"
                  v-if="hasItems(item)"
                >
                  <template v-for="(subitem, index) of item.subItems">
                    <a

                      :class="{'text-white' : content[filterStylesKey(content, 'layout_colour')].layout_colour.value == 'Dark'}"
                      class="col dropdown-item side-nav-link-ref"
                      :key="index"
                      v-if="!hasItems(subitem) && liveMode == false"
                      :href="subitem.link"
                      >{{ $t(subitem.label) }}</a
                    >
                     <router-link

                      :class="{'text-white' : content[filterStylesKey(content, 'layout_colour')].layout_colour.value == 'Dark'}"
                      class="col dropdown-item side-nav-link-ref"
                      :key="index"
                      v-if="!hasItems(subitem) && liveMode == true"
                      :to="subitem.link"
                      >{{ $t(subitem.label) }}</router-link
                    >
                    <div class="dropdown" v-if="hasItems(subitem)" :key="index">
                      <a
                        :class="{'text-white' : content[filterStylesKey(content, 'layout_colour')].layout_colour.value == 'Dark'}" 
                        class="dropdown-item dropdown-toggle"
                        href="javascript: void(0);"
                        @click="onMenuClick($event)"
                         @mouseover="onMenuHover($event)"
                         @mouseout="onMenuHover(null)"
                        >{{ $t(subitem.label) }}
                        <div class="arrow-down"></div>
                      </a>
                      <div class="dropdown-menu">
                        <template
                          v-for="(subSubitem, index) of subitem.subItems"
                        >
                          <a

                            :class="{'text-white' : content[filterStylesKey(content, 'layout_colour')].layout_colour.value == 'Dark'}"
                            class="dropdown-item side-nav-link-ref"
                            :key="index"
                            v-if="!hasItems(subSubitem) && liveMode == false"
                            :href="subSubitem.link"
                            >{{ $t(subSubitem.label) }}</a
                          >
                          <router-link

                            :class="{'text-white' : content[filterStylesKey(content, 'layout_colour')].layout_colour.value == 'Dark'}"
                            class="dropdown-item side-nav-link-ref"
                            :key="index"
                            v-if="!hasItems(subSubitem) && liveMode == true"
                            :to="subSubitem.link"
                            >{{ $t(subSubitem.label) }}</router-link
                          >
                          <div
                            class="dropdown"
                            v-if="hasItems(subSubitem)"
                            :key="index"
                          >
                            <a

                              :class="{'text-white' : content[filterStylesKey(content, 'layout_colour')].layout_colour.value == 'Dark'}"
                              class="dropdown-item dropdown-toggle"
                              href="javascript: void(0);"
                              @click="onMenuClick($event)"
                               @mouseover="onMenuHover($event)"
                               @mouseout="onMenuHover(null)"
                              >{{ $t(subSubitem.label) }}
                              <div class="arrow-down"></div>
                            </a>
                            <div class="dropdown-menu">
                              <template
                                v-for="(
                                  subSubSubitem, index
                                ) of subSubitem.subItems"
                              >
                                <a

                                  :class="{'text-white' : content[filterStylesKey(content, 'layout_colour')].layout_colour.value == 'Dark'}"
                                  class="dropdown-item side-nav-link-ref"
                                  :key="index"
                                  :href="subSubSubitem.link"
                                  routerLinkActive="active"
                                  >{{ $t(subSubSubitem.label) }}</a
                                >
                              </template>
                            </div>
                          </div>
                        </template>
                      </div>
                    </div>
                  </template>
                </div>
              </li>
            </template>-->
          </ul>
        </div>
        <div id="topnav-menu-content" v-else-if="liveMode == false" class="justify-content-center collapse navbar-collapse">
          <ul class="navbar-nav">
            <!-- Menu data -->

            <template v-for="(item, index) of menuItems">
              <li class="nav-item dropdown" :key="index">
                <a
                  class="nav-link dropdown-toggle arrow-none"
                  v-if="!hasItems(item)"
                  id="topnav-components"
                  :href="'#'"
                  role="button"
                  :class="{'text-white' : content[filterStylesKey(content, 'layout_colour')].layout_colour.value == 'Dark'}"
                  :style="compileElementStyles('menu_text', ['text'])"
                >
                  <i :class="`bx ${item.icon} mr-2`"></i>{{ $t(item.label) }}
                  <div class="arrow-down" v-if="hasItems(item)"></div>
                </a>

                <a
                  v-else
                  class="nav-link dropdown-toggle arrow-none"
                  @click="onMenuClick($event)"
                  @mouseover="onMenuHover([index])"
                 
                  href="javascript: void(0);"
                  id="topnav-components"
                  role="button"
                  :class="{'text-white' : content[filterStylesKey(content, 'layout_colour')].layout_colour.value == 'Dark'}"
                  :style="compileElementStyles('menu_text', ['text'])"
                >
                  <i :class="`bx ${item.icon} mr-1`"></i>
                  {{ $t(item.label) }}
                  <div class="arrow-down"></div>
                </a>

                <div
                  class="dropdown-menu m-w-100"
                  :class="{'bg-dark' : content[filterStylesKey(content, 'layout_colour')].layout_colour.value == 'Dark', 'show' : itemHovered[0] == index}"
                  aria-labelledby="topnav-dashboard"
                  v-if="hasItems(item) && (itemHovered[0] == index)"
                >
                  <template v-for="(subitem, index) of item.menuitems">
                    <a
                      class="col dropdown-item side-nav-link-ref"
                      :class="{'text-white' : content[filterStylesKey(content, 'layout_colour')].layout_colour.value == 'Dark'}"
                      :key="index"
                      v-if="!hasItems(subitem)"
                      :style="compileElementStyles('dropdown_text', ['text'])"
                      :href="'#'"
                      >{{ subitem.label }}</a
                    >

                    <div class="dropdown" v-if="hasItems(subitem)" :key="index">
                      <a
                        class="dropdown-item dropdown-toggle"
                        href="javascript: void(0);"
                        :class="{'text-white' : content[filterStylesKey(content, 'layout_colour')].layout_colour.value == 'Dark'}"
                        :style="compileElementStyles('dropdown_text', ['text'])"
                        @click="onMenuClick($event)"
                         @mouseover="onMenuHover($event)"
                         @mouseout="onMenuHover(null)"
                        >{{ subitem.label }}
                        <div class="arrow-down"></div>
                      </a>
                      <div class="dropdown-menu" :class="{'bg-dark' : content[filterStylesKey(content, 'layout_colour')].layout_colour.value == 'Dark'}">
                        <template
                          v-for="(subSubitem, index) of subitem.menuitems"
                        >
                          <a
                            class="dropdown-item side-nav-link-ref"
                            :key="index"
                            v-if="!hasItems(subSubitem)"
                            href="#"
                            :style="compileElementStyles('dropdown_text', ['text'])"
                            :class="{'text-white' : content[filterStylesKey(content, 'layout_colour')].layout_colour.value == 'Dark'}"
                            >{{ subSubitem.label }}</a
                          >
                          <div
                            class="dropdown"
                            v-if="hasItems(subSubitem)"
                            :key="index"
                          >
                            <a
                              class="dropdown-item dropdown-toggle"
                              href="javascript: void(0);"
                              @click="onMenuClick($event)"
                               @mouseover="onMenuHover($event)"
                               @mouseout="onMenuHover(null)"
                              :class="{'text-white' : content[filterStylesKey(content, 'layout_colour')].layout_colour.value == 'Dark'}"
                              :style="compileElementStyles('dropdown_text', ['text'])"
                              >{{ subSubitem.label }}
                              <div class="arrow-down"></div>
                            </a>
                            <div class="dropdown-menu" :class="{'bg-dark' : content[filterStylesKey(content, 'layout_colour')].layout_colour.value == 'Dark'}">
                              <template
                                v-for="(
                                  subSubSubitem, index
                                ) of subSubitem.menuitems"
                              >
                                <a
                                  class="dropdown-item side-nav-link-ref"
                                  :key="index"
                                  :href="'#'"
                                  routerLinkActive="active"
                                  :style="compileElementStyles('dropdown_text', ['text'])"
                                  >{{ $t(subSubSubitem.label) }}</a
                                >
                              </template>
                            </div>
                          </div>
                        </template>
                      </div>
                    </div>
                  </template>
                </div>
              </li>
            </template>
          </ul>
          <ul class="navbar-nav">
            <!-- Menu data -->

            <!--<template v-for="(item, index) of menuItems">
              <li class="nav-item dropdown" :key="index">
                <a
                  class="nav-link dropdown-toggle arrow-none"
                  v-if="!item.subItems && liveMode == false"
                  id="topnav-components"
                  :href="item.link"
                  role="button"
                  :class="{'text-white' : content[filterStylesKey(content, 'layout_colour')].layout_colour.value == 'Dark'}"
                >
                  <i :class="`bx ${item.icon} mr-2`"></i>{{ $t(item.label) }}
                  <div class="arrow-down" v-if="hasItems(item)"></div>
                </a>
                <router-link
                  class="nav-link dropdown-toggle arrow-none"
                  v-if="!item.subItems && liveMode == true"
                  id="topnav-components"
                  :to="item.link"
                  role="button"
                  :class="{'text-white' : content[filterStylesKey(content, 'layout_colour')].layout_colour.value == 'Dark'}"
                >
                  <i :class="`bx ${item.icon} mr-2`"></i>{{ $t(item.label) }}
                  <div class="arrow-down" v-if="hasItems(item)"></div>
                </router-link>

                <a
                  v-if="item.subItems"
                  class="nav-link dropdown-toggle arrow-none"
                  @click="onMenuClick($event)"
                   @mouseover="onMenuHover($event)"
                   @mouseout="onMenuHover(null)"
                  href="javascript: void(0);"
                  id="topnav-components"
                  role="button"
                  :class="{'text-white' : content[filterStylesKey(content, 'layout_colour')].layout_colour.value == 'Dark'}"
                >
                  <i :class="`bx ${item.icon} mr-1`"></i>
                  {{ $t(item.label) }}
                  <div class="arrow-down"></div>
                </a>

                <div

                  :class="{'bg-dark' : content[filterStylesKey(content, 'layout_colour')].layout_colour.value == 'Dark'}"
                  class="dropdown-menu"
                  aria-labelledby="topnav-dashboard"
                  v-if="hasItems(item)"
                >
                  <template v-for="(subitem, index) of item.subItems">
                    <a

                      :class="{'text-white' : content[filterStylesKey(content, 'layout_colour')].layout_colour.value == 'Dark'}"
                      class="col dropdown-item side-nav-link-ref"
                      :key="index"
                      v-if="!hasItems(subitem) && liveMode == false"
                      :href="subitem.link"
                      >{{ $t(subitem.label) }}</a
                    >
                     <router-link

                      :class="{'text-white' : content[filterStylesKey(content, 'layout_colour')].layout_colour.value == 'Dark'}"
                      class="col dropdown-item side-nav-link-ref"
                      :key="index"
                      v-if="!hasItems(subitem) && liveMode == true"
                      :to="subitem.link"
                      >{{ $t(subitem.label) }}</router-link
                    >
                    <div class="dropdown" v-if="hasItems(subitem)" :key="index">
                      <a
                        :class="{'text-white' : content[filterStylesKey(content, 'layout_colour')].layout_colour.value == 'Dark'}" 
                        class="dropdown-item dropdown-toggle"
                        href="javascript: void(0);"
                        @click="onMenuClick($event)"
                         @mouseover="onMenuHover($event)"
                         @mouseout="onMenuHover(null)"
                        >{{ $t(subitem.label) }}
                        <div class="arrow-down"></div>
                      </a>
                      <div class="dropdown-menu">
                        <template
                          v-for="(subSubitem, index) of subitem.subItems"
                        >
                          <a

                            :class="{'text-white' : content[filterStylesKey(content, 'layout_colour')].layout_colour.value == 'Dark'}"
                            class="dropdowthis.$attrs.parentn-item side-nav-link-ref"
                            :key="index"
                            v-if="!hasItems(subSubitem) && liveMode == false"
                            :href="subSubitem.link"
                            >{{ $t(subSubitem.label) }}</a
                          >
                          <router-link

                            :class="{'text-white' : content[filterStylesKey(content, 'layout_colour')].layout_colour.value == 'Dark'}"
                            class="dropdown-item side-nav-link-ref"
                            :key="index"
                            v-if="!hasItems(subSubitem) && liveMode == true"
                            :to="subSubitem.link"
                            >{{ $t(subSubitem.label) }}</router-link
                          >
                          <div
                            class="dropdown"
                            v-if="hasItems(subSubitem)"
                            :key="index"
                          >
                            <a

                              :class="{'text-white' : content[filterStylesKey(content, 'layout_colour')].layout_colour.value == 'Dark'}"
                              class="dropdown-item dropdown-toggle"
                              href="javascript: void(0);"
                              @click="onMenuClick($event)"
                               @mouseover="onMenuHover($event)"
                               @mouseout="onMenuHover(null)"
                              >{{ $t(subSubitem.label) }}
                              <div class="arrow-down"></div>
                            </a>
                            <div class="dropdown-menu">
                              <template
                                v-for="(
                                  subSubSubitem, index
                                ) of subSubitem.subItems"
                              >
                                <a

                                  :class="{'text-white' : content[filterStylesKey(content, 'layout_colour')].layout_colour.value == 'Dark'}"
                                  class="dropdown-item side-nav-link-ref"
                                  :key="index"
                                  :href="subSubSubitem.link"
                                  routerLinkActive="active"
                                  >{{ $t(subSubSubitem.label) }}</a
                                >
                              </template>
                            </div>
                          </div>
                        </template>
                      </div>
                    </div>
                  </template>
                </div>
              </li>
            </template>-->
          </ul>
        </div>
      </nav>
    </div>
  </div>
    <b-modal id="register" centered content-class="border-radius-1em" header-class="border-none" hide-footer>
       <Register @login="$bvDropdown.show('account-dropdown')" submit-url="/account/register" :regError="$attrs.regError">
              <input type="hidden" name="_token" :value="csrf">
            </Register>
    </b-modal>
  </header>
  <header v-else>
    <div class="navbar-header" :class="{'bg-dark' : content[filterStylesKey(content, 'layout_colour')].layout_colour.value == 'Dark'}">
        <div class="d-flex" :class="{'w-auto' : content[filterStylesKey(content, 'logo_position')].logo_position.value == 'logo left'}">
        <!-- LOGO -->
        <div class="navbar-brand-box px-0 bg-transparent" :class="{'text-center mx-auto' : content[filterStylesKey(content, 'logo_position')].logo_position.value == 'logo center'}" v-if="content[filterStylesKey(content, 'logo_position')].logo_position.value !== 'logo right'">
          <a href="/" class="logo" >
            <span class="logo-sm">
              <img v-if="content[filterStylesKey(content, 'logo')].logo.value !== ''" :src="content[filterStylesKey(content, 'logo')].logo.value" :width="content[filterStylesKey(content, 'logo')].logo.width.value + content[filterStylesKey(content, 'logo')].logo.width.units" :height="content[filterStylesKey(content, 'logo')].logo.height.value + content[filterStylesKey(content, 'logo')].logo.height.units">
              <div v-else class="d-flex logo-text-holder"><span class="logo-text">{{company.name.slice(0, 1)}}</span></div>
            </span>
            <span class="logo-lg">
              <img v-if="content[filterStylesKey(content, 'logo')].logo.value !== ''" :src="content[filterStylesKey(content, 'logo')].logo.value" :width="content[filterStylesKey(content, 'logo')].logo.width.value + content[filterStylesKey(content, 'logo')].logo.width.units" :height="content[filterStylesKey(content, 'logo')].logo.height.value + content[filterStylesKey(content, 'logo')].logo.height.units">
              <div v-else class="d-flex logo-text-holder"><span class="logo-text" :class="{'text-dark' : content[filterStylesKey(content, 'layout_colour')].layout_colour.value == 'Light', 'text-white' : content[filterStylesKey(content, 'layout_colour')].layout_colour.value == 'Dark'}">{{company.name}}</span></div>
            </span>
          </a>

          
        </div>

        <button
          id="toggle"
          type="button"
          class="btn btn-sm me-2 font-size-16 d-lg-none header-item"
          @click="toggleMenu"
        >
          <i class="fa fa-fw fa-bars"></i>

        </button>
        <button
          id="toggleClose"
          type="button"
          class="btn btn-sm me-2 font-size-16 d-lg-none header-item d-none position-fixed top-0 right-0 mr-2"
          @click="toggleMenu"
        >

          <i class="fas fa-fw fa-times"></i>
        </button>
        
      </div>
      <div class="d-flex w-75">
        <nav class="navbar navbar-light navbar-expand-lg topnav-menu">
        <div id="topnav-menu-content" class="justify-content-center collapse navbar-collapse" v-if="liveMode == true">
          <ul class="navbar-nav">
            <!-- Menu data -->
            <template v-for="(item, index) of menuItems">
              <li class="nav-item dropdown" :key="index" @mouseleave="onMenuHover([])">
                <router-link
                  class="nav-link dropdown-toggle arrow-none"
                  v-if="!hasItems(item)"
                  id="topnav-components"
                  :to="constructLink(item.link)"
                  role="button"
                  :class="{'text-white' : content[filterStylesKey(content, 'layout_colour')].layout_colour.value == 'Dark'}"
                  :style="compileElementStyles('menu_text', ['text'])"
                >
                  <i :class="`bx ${item.icon} mr-2`"></i>{{ item.label }}
                  <div class="arrow-down" v-if="hasItems(item)"></div>
                </router-link>

                <a
                  v-else
                  class="nav-link dropdown-toggle arrow-none"
                  @click="onMenuClick($event)"
                   @mouseover="onMenuHover([index])"
                   
                  href="javascript: void(0);"
                  id="topnav-components"
                  role="button"
                  :class="{'text-white' : content[filterStylesKey(content, 'layout_colour')].layout_colour.value == 'Dark'}"
                  :style="compileElementStyles('menu_text', ['text'])"
                >
                  <i :class="`bx ${item.icon} mr-1`"></i>
                  {{ item.label }}
                  <div class="arrow-down"></div>
                </a>

                <div
                  class="dropdown-menu m-w-100"
                  :class="{'bg-dark' : content[filterStylesKey(content, 'layout_colour')].layout_colour.value == 'Dark', 'show' : itemHovered[0] == index}"
                  aria-labelledby="topnav-dashboard"
                  v-if="hasItems(item) && (itemHovered[0] == index)"
                >
                  <template v-for="(subitem, subindex) of item.menuitems">
                    <router-link
                      class="col dropdown-item side-nav-link-ref"
                      :class="{'text-white' : content[filterStylesKey(content, 'layout_colour')].layout_colour.value == 'Dark'}"
                      :key="index"
                      :style="compileElementStyles('dropdown_text', ['text'])"
                      v-if="!hasItems(subitem)"
                      :to="constructLink( subitem.link)"
                      >{{ subitem.label }}</router-link
                    >

                    <div class="dropdown" v-if="hasItems(subitem)" :key="index">
                      <a
                        class="dropdown-item dropdown-toggle d-flex"
                        href="javascript: void(0);"
                        :class="{'text-white' : content[filterStylesKey(content, 'layout_colour')].layout_colour.value == 'Dark'}"
                        :style="compileElementStyles('dropdown_text', ['text'])"
                        @click="onMenuClick($event)"
                         @mouseover="onMenuHover([index, subindex])"
                        >{{ subitem.label }}
                        <div class="arrow-right"></div>
                      </a>
                      <div class="dropdown-menu dropright" :class="{'bg-dark' : content[filterStylesKey(content, 'layout_colour')].layout_colour.value == 'Dark', 'show' : (itemHovered[0] == index) && (itemHovered[1] == subindex)}">
                        <template
                          v-for="(subSubitem, subSubindex) of subitem.menuitems"
                        >
                          <router-link
                            class="dropdown-item side-nav-link-ref"
                            :key="index"
                            v-if="!hasItems(subSubitem)"
                            :to="'/' + subSubitem.link"
                            :class="{'text-white' : content[filterStylesKey(content, 'layout_colour')].layout_colour.value == 'Dark'}"
                            :style="compileElementStyles('dropdown_text', ['text'])"
                            >{{ subSubitem.label }}</router-link>
                          <div
                            class="dropdown dropright"
                            v-if="hasItems(subSubitem)"
                            :key="index"
                          >
                            <a
                              class="dropdown-item dropdown-toggle d-flex"
                              href="javascript: void(0);"
                              @click="onMenuClick($event)"
                               @mouseover="onMenuHover([index, subindex, subSubindex])"
                              :class="{'text-white' : content[filterStylesKey(content, 'layout_colour')].layout_colour.value == 'Dark'}"
                              :style="compileElementStyles('dropdown_text', ['text'])"
                              >{{ subSubitem.label }}
                              <div class="arrow-right"></div>
                            </a>
                            <div class="dropdown-menu dropright" :class="{'bg-dark' : content[filterStylesKey(content, 'layout_colour')].layout_colour.value == 'Dark', 'show' : (itemHovered[0] == index) && (itemHovered[1] == subindex) && (itemHovered[2] == subSubindex)}">
                              <template
                                v-for="(
                                  subSubSubitem, index
                                ) of subSubitem.menuitems"
                              >
                                <router-link
                                  class="dropdown-item side-nav-link-ref"
                                  :key="index"
                                  :to="'/' + subSubSubitem.link"
                                  routerLinkActive="active"
                                  :style="compileElementStyles('dropdown_text', ['text'])"
                                  >{{ subSubSubitem.label }}</router-link
                                >
                              </template>
                            </div>
                          </div>
                        </template>
                      </div>
                    </div>
                  </template>
                </div>
              </li>
            </template>
          </ul>
        </div>
        <div id="topnav-menu-content" class="justify-content-center collapse navbar-collapse" v-else-if="liveMode == false">
          <ul class="navbar-nav">
            <!-- Menu data -->
            <template v-for="(item, index) of menuItems">
              <li class="nav-item dropdown" :key="index">
                <a
                  class="nav-link dropdown-toggle arrow-none"
                  v-if="!hasItems(item)"
                  id="topnav-components"
                  :to="constructLink(item.link)"
                  role="button"
                  :class="{'text-white' : content[filterStylesKey(content, 'layout_colour')].layout_colour.value == 'Dark'}"
                >
                  <i :class="`bx ${item.icon} mr-2`"></i>{{ $t(item.label) }}
                  <div class="arrow-down" v-if="hasItems(item)"></div>
                </a>

                <a
                  v-else
                  class="nav-link dropdown-toggle arrow-none"
                  @click="onMenuClick($event)"
                   @mouseover="onMenuHover(item)"
                   @mouseout="onMenuHover(null)"
                  href="javascript: void(0);"
                  id="topnav-components"
                  role="button"
                  :class="{'text-white' : content[filterStylesKey(content, 'layout_colour')].layout_colour.value == 'Dark'}"
                >
                  <i :class="`bx ${item.icon} mr-1`"></i>
                  {{ $t(item.label) }}
                  <div class="arrow-down"></div>
                </a>

                <div
                  class="dropdown-menu m-w-100" :class="{'bg-dark' : content[filterStylesKey(content, 'layout_colour')].layout_colour.value == 'Dark'}"
                  aria-labelledby="topnav-dashboard"
                  v-if="hasItems(item) && (itemHovered[0] == index)"
                >
                  <template v-for="(subitem, index) of item.menuitems">
                    <a
                      class="col dropdown-item side-nav-link-ref"
                      :class="{'text-white' : content[filterStylesKey(content, 'layout_colour')].layout_colour.value == 'Dark'}"
                      :key="index"
                      v-if="!hasItems(subitem)"
                      :to="subitem.link"
                      >{{ $t(subitem.label) }}</a
                    >

                    <div class="dropdown" v-if="hasItems(subitem)" :key="index">
                      <a
                        class="dropdown-item dropdown-toggle"
                        href="javascript: void(0);"
                        :class="{'text-white' : content[filterStylesKey(content, 'layout_colour')].layout_colour.value == 'Dark'}"
                        @click="onMenuClick($event)"
                         @mouseover="onMenuHover($event)"
                         @mouseout="onMenuHover(null)"
                        >{{ $t(subitem.label) }}
                        <div class="arrow-down"></div>
                      </a>
                      <div class="dropdown-menu" :class="{'bg-dark' : content[filterStylesKey(content, 'layout_colour')].layout_colour.value == 'Dark'}">
                        <template
                          v-for="(subSubitem, index) of subitem.menuitems"
                        >
                          <a
                            class="dropdown-item side-nav-link-ref"
                            :key="index"
                            v-if="!hasItems(subSubitem)"
                            :href="subSubitem.link"
                            :class="{'text-white' : content[filterStylesKey(content, 'layout_colour')].layout_colour.value == 'Dark'}"
                            >{{ $t(subSubitem.label) }}</a
                          >
                          <div
                            class="dropdown"
                            v-if="hasItems(subSubitem)"
                            :key="index"
                          >
                            <a
                              class="dropdown-item dropdown-toggle"
                              href="javascript: void(0);"
                              @click="onMenuClick($event)"
                               @mouseover="onMenuHover($event)"
                               @mouseout="onMenuHover(null)"
                              :class="{'text-white' : content[filterStylesKey(content, 'layout_colour')].layout_colour.value == 'Dark'}"
                              >{{ $t(subSubitem.label) }}
                              <div class="arrow-down"></div>
                            </a>
                            <div class="dropdown-menu" :class="{'bg-dark' : content[filterStylesKey(content, 'layout_colour')].layout_colour.value == 'Dark'}">
                              <template
                                v-for="(
                                  subSubSubitem, index
                                ) of subSubitem.menuitems"
                              >
                                <a
                                  class="dropdown-item side-nav-link-ref"
                                  :key="index"
                                  :href="subSubSubitem.link"
                                  routerLinkActive="active"
                                  >{{ $t(subSubSubitem.label) }}</a
                                >
                              </template>
                            </div>
                          </div>
                        </template>
                      </div>
                    </div>
                  </template>
                </div>
              </li>
            </template>
          </ul>
        </div>
      </nav>
      </div>
      <transition name="fade-right">
         <form class="app-search d-none d-lg-block ml-auto w-50 my-auto" v-if="(showSearch == true) && (content[filterStylesKey(content, 'logo_position')].logo_position.value == 'logo left')" >
          <div class="position-relative">
            <input
              type="text"
              class="form-control bg-light bg-soft"
              :placeholder="$t('navbar.search.text')"
               :class="{'bg-dark' : content[filterStylesKey(content, 'layout_colour')].layout_colour.value == 'Dark', 'bg-light' : content[filterStylesKey(content, 'layout_colour')].layout_colour.value == 'Light'}"
            />
            <span class="bx bx-search-alt" :class="{'text-light' : content[filterStylesKey(content, 'layout_colour')].layout_colour.value == 'Dark'}" ></span>
          </div>
        </form>
      </transition>
      <transition name="fade-top">
         <form class="app-search d-none d-lg-block mx-auto w-50 my-auto position-absolute top-0 right-0 left-0" v-if="(showSearch == true) && ((content[filterStylesKey(content, 'logo_position')].logo_position.value == 'logo center') || (content[filterStylesKey(content, 'logo_position')].logo_position.value == 'logo right'))"  :class="{'bg-dark' : content[filterStylesKey(content, 'layout_colour')].layout_colour.value == 'Dark', 'bg-white' : content[filterStylesKey(content, 'layout_colour')].layout_colour.value == 'Light'}" >
          <div class="position-relative">
            <input
              type="text"
              class="form-control bg-light bg-soft"
              :placeholder="$t('navbar.search.text')"
               :class="{'bg-dark' : content[filterStylesKey(content, 'layout_colour')].layout_colour.value == 'Dark', 'bg-light' : content[filterStylesKey(content, 'layout_colour')].layout_colour.value == 'Light'}"
            />
            <span class="bx bx-search-alt" :class="{'text-light' : content[filterStylesKey(content, 'layout_colour')].layout_colour.value == 'Dark'}" ></span>
          </div>
        </form>
      </transition>
      <div class="d-flex"  :class="{'ml-auto' : content[filterStylesKey(content, 'logo_position')].logo_position.value == 'logo left', 'mr-auto' : content[filterStylesKey(content, 'logo_position')].logo_position.value == 'logo right', 'ml-auto w-25' : content[filterStylesKey(content, 'logo_position')].logo_position.value == 'logo center'}">
        <b-dropdown
          v-if="(elements[filterStylesKey(elements, 'show_search')].show_search.value == true) && (content[filterStylesKey(content, 'logo_position')].logo_position.value !== 'logo center')"
          class="d-inline-block d-lg-none ml-2"
          variant="black"
          menu-class="dropdown-menu-lg p-0 dropdown-menu-end"
          :menu-class="{'bg-dark' : content[filterStylesKey(content, 'layout_colour')].layout_colour.value == 'Dark'}"
          toggle-class="header-item noti-icon"
          right
        >
          <template v-slot:button-content>
            <i class="mdi mdi-magnify"></i>
          </template>

          <form class="p-3">
            <div class="form-group m-0">
              <div class="input-group">
                <input
                  type="text"
                  class="form-control"
                  placeholder="Search ..."
                  aria-label="Recipient's username"
                />
                <div class="input-group-append">
                  <button class="btn btn-primary" type="submit">
                    <i class="mdi mdi-magnify"></i>
                  </button>
                </div>
              </div>
            </div>
          </form>
        </b-dropdown>

        <!--<b-dropdown variant="white" right toggle-class="header-item">
          <template v-slot:button-content>
            <img class :src="flag" alt="Header Language" height="16" />
            {{ text }}
          </template>
          <b-dropdown-item
            class="notify-item"
            v-for="(entry, i) in languages"
            :key="`Lang${i}`"
            :value="entry"
            @click="setLanguage(entry.language, entry.title, entry.flag)"
            :class="{ active: lan === entry.language }"
          >
            <img
              :src="`${entry.flag}`"
              alt="user-image"
              class="me-1"
              height="12"
            />
            <span class="align-middle">{{ entry.title }}</span>
          </b-dropdown-item>
        </b-dropdown>-->



        <!--<div class="dropdown d-none d-lg-inline-block ml-1">
          <button
            type="button"
            class="btn header-item noti-icon"
            @click="initFullScreen"
          >
            <i class="bx bx-fullscreen"></i>
          </button>
        </div>-->
        <div class="dropdown d-none d-lg-inline-block ml-1">
          <button  
            v-if="(elements[filterStylesKey(elements, 'show_search')].show_search.value == true) && (content[filterStylesKey(content, 'logo_position')].logo_position.value !== 'logo center')"
            type="button"
            class="btn header-item noti-icon"
            @click="showSearch = !showSearch"
          >
            <i class="bx bx-search" :class="{'text-white' : content[filterStylesKey(content, 'layout_colour')].layout_colour.value == 'Dark'}"></i>
          </button>
        </div>
        <b-dropdown
          v-if="(elements[filterStylesKey(elements, 'show_currency')].show_currency.value == true) && (content[filterStylesKey(content, 'logo_position')].logo_position.value !== 'logo center')"
          variant="white" right toggle-class="header-item noti-icon"
        >
          <template v-slot:button-content>
            <i :class="[`${currencyicon}`, {'text-white' : content[filterStylesKey(content, 'layout_colour')].layout_colour.value == 'Dark'}]" :alt="'Pay in ' + currency" ></i>
          </template>

           <b-dropdown-item
            class="notify-item"
            v-for="(entry, i) in currencies"
            :key="`Lang${i}`"
            :value="entry"
            @click="setCurrency(entry.code, entry.name, entry.icon, entry.symbol, entry)"
            :class=" {'active' : lan === entry.language}"
          >
            <i :class="`${entry.icon}`" :alt="'Pay in ' + entry.name" class="me-1" ></i>
            <span class="align-middle">{{ entry.name }}</span>
          </b-dropdown-item>
        </b-dropdown>
        <b-dropdown
        v-if="elements[filterStylesKey(elements, 'show_cart')].show_cart.value == true"
          right
          class="cart-drop"
          menu-class="dropdown-menu-lg p-0 dropdown-menu-end cart-dropdown border-radius-1em"
          :menu-class="{'bg-dark' : content[filterStylesKey(content, 'layout_colour')].layout_colour.value == 'Dark'}"
          toggle-class="header-item noti-icon"
          variant="black"
          ref="cart"
          :class="{'ml-auto' : content[filterStylesKey(content, 'logo_position')].logo_position.value == 'logo center'}"
        >
          <template v-slot:button-content>
            <i class="bx bx-shopping-bag" :class="{'text-white' : content[filterStylesKey(content, 'layout_colour')].layout_colour.value == 'Dark'}"></i>
            <span
              class="badge bg-danger rounded-pill"
            >{{cart.products.length}}</span>
          </template>

          <div class="p-3">
            <div class="row align-items-center">
              <div class="col">
                <h6 class="m-0">Shopping Cart</h6>
              </div>
              <div class="col-auto">
                <a href="#" class="small">View Cart</a>
              </div>
            </div>
          </div>
          <simplebar style="max-height: 430px;">
          <b-list-group v-if="cartLoading == false">
            <b-list-group-item  v-for="(productitem, index) in cart.products" href="javascript: void(0);" class="text-reset notification-item px-0 py-3 m-0">
              <div class="media">
                <div class="avatar-sm me-3">
                  <img v-if="productitem.product.cover_image" :src="storageurl+productitem.product.cover_image.src.replaceAll('//', '/')" class="avatar-title rounded-circle">
                  <span v-else class="avatar-title bg-primary rounded-circle font-size-16" >
                    <i class="bx bx-cart"></i>
                  </span>
                </div>
                <div class="cart-name-cell my-auto w-50">
                  <h6 class="mt-0 mb-1 text-truncate">{{productitem.product.name}}</h6>
                </div>
                <div class="my-auto text-right d-flex flex-column mx-auto">
                  <a href="javascript:;" class="text-center" @click="productitem.quantity++"><i class="bx bx-chevron-up mb-auto mx-auto"></i></a>
                  <b-form-input type="number"  v-model="productitem.quantity" class="visible mx-auto my-auto d-none" style="width: 25%;" >
                  </b-form-input>
                  <span class="mx-auto my-auto">{{productitem.quantity}}</span>
                  <a v-if="productitem.quantity > 1" href="javascript:;" class="text-center" @click="productitem.quantity--"><i class="bx bx-chevron-down mt-auto mx-auto"></i></a>
                  <a v-else href="javascript:;" class="text-center" @click="removeProduct(productitem.id, index)"><i class="bx bx-chevron-down mt-auto mx-auto"></i></a>
                </div>
                <div class="my-auto text-center d-flex flex-column mx-auto">
                  <p class="mb-0"><span class="text-muted">£</span>{{productitem.price_exc}}</p>
                  <small>Item Price Exc</small>
                </div>
                <div class="my-auto text-center d-flex flex-column mx-auto">
                  <p class="mb-0"><span class="text-muted">£</span>{{(productitem.price_exc * productitem.quantity).toFixed(2)}}</p>
                  <small>Total Price Exc</small>
                </div>
                <div class="my-auto mx-auto text-center">
                 <a class="btn btn-outline-light btn-rounded" @click="removeProduct(productitem.id, index)"><i class="bx bx-trash-alt"></i></a>
                </div>
              </div>
            </b-list-group-item>
            <b-list-group-item v-if="cart.products.length == 0">
              <div class="p-5 text-center border">
                <i class="bx bx-shopping-bag font-size-42 text-secondary mb-2"></i>
                <h6>No Products in Cart</h6>
              </div>
            </b-list-group-item>
          </b-list-group>
            

          </simplebar>
          <b-overlay
            :show="cartLoading">
              <div class="p-4 border-top d-flex bg-light" v-if="(cart.products.length !== 0) && (cartLoading == false)">
                <strong class="mr-auto flex-grow-2"> Total: </strong>
                  <span class="mx-auto flex-grow-1 text-center"><strong class="text-primary mr-2">£</strong> {{cartTotal(cart)}}</span>
              </div>
          </b-overlay>
         <div class="p-2 border-top d-grid" v-if="cart.products.length !== 0">
            <a class="btn btn-sm btn-link font-size-14 text-center btn-primary text-white btn-rounded" :href="{ name: 'Order', path: '/order', params: { cart } }"  >
              <i class=" me-1"></i>
              <span key="t-view-more"> Checkout Now </span>
            </a>
          </div>
        </b-dropdown>
        <b-dropdown
        v-if="elements[filterStylesKey(elements, 'show_account')].show_account.value == true"
          right
          variant="black"
          class="account-drop"
          toggle-class="header-item"
          menu-class="dropdown-menu-end"
          :menu-class="{'border-radius-1em p-0 login-dropdown dropdown-menu-end' : !user, 'bg-dark text-white' : content[filterStylesKey(content, 'layout_colour')].layout_colour.value == 'Dark'}"
        >
          <template v-slot:button-content>
            <div v-if="user">
            <img
              v-if="user.avatar"
              class="rounded-circle header-profile-user"
              :src="user.avatar"
              alt="Header Avatar"
            />
            <img v-else
              class="rounded-circle header-profile-user"
              src="/images/product-placeholder.png"
            > 
            <span class="d-none d-xl-inline-block ml-1" :class="{'text-white' : content[filterStylesKey(content, 'layout_colour')].layout_colour.value == 'Dark'}">{{user.name}} {{user.lastname}}</span>
            <i class="mdi mdi-chevron-down d-none d-xl-inline-block"></i>
            </div>
            <div v-else>
              <img
              class="rounded-circle header-profile-user"
              src="/images/product-placeholder.png"
              alt="Sign in to Gemesys"
            />
            <span class="d-none d-xl-inline-block ml-1" :class="{'text-white' : content[filterStylesKey(content, 'layout_colour')].layout_colour.value == 'Dark'}">
              My Account
            </span>
            <i class="mdi mdi-chevron-down d-none d-xl-inline-block"></i>
            </div>

            
          </template>
          <!-- item-->
           <div v-if="user">
          <b-dropdown-item href="/account">
            <i class="bx bx-user font-size-16 align-middle me-1"></i>
            My Account
          </b-dropdown-item>
          <b-dropdown-item href="/account#addresses">
            <i class="bx bx-home-alt font-size-16 align-middle me-1"></i>
            Addresses
          </b-dropdown-item>
          <b-dropdown-item href="/account#orders">
            <i class="bx bx-tag font-size-16 align-middle me-1"></i>
            Orders
          </b-dropdown-item>
          <b-dropdown-item class="d-block"  href="/account#messages">
            <span class="badge bg-success float-end">11</span>
            <i class="bx bx-chat font-size-16 align-middle me-1"></i>
            Messages
          </b-dropdown-item>
          <b-dropdown-item  href="/account#wishlist">
            <i class="mdi mdi-heart-outline font-size-16 align-middle me-1"></i>
            Wishlist
          </b-dropdown-item>

          <b-dropdown-divider></b-dropdown-divider>
          <a href="/account/logout" class="dropdown-item text-danger">
            <i
              class="bx bx-power-off font-size-16 align-middle me-1 text-danger"
            ></i>
            {{ $t("navbar.dropdown.henry.list.logout") }}
          </a>
          </div>
          <div v-else class="p-0">
            <Login :submit-url="'http://website.'+domain.domain_key+'.gemesys.co.uk/account/login'" auth-error="" @register="$bvModal.show('register')">
                 <input type="hidden" name="_token" :value="csrf">
            </Login>
          </div>
        </b-dropdown>
      
        <!--<div class="dropdown d-inline-block">
          <button
            type="button"
            class="btn header-item noti-icon right-bar-toggle toggle-right"
            @click="toggleRightSidebar"
          >
            <i class="bx bx-cog bx-spin toggle-right"></i>
          </button>
        </div>-->
      </div>
    </div>

  <b-modal id="register" centered content-class="border-radius-1em" header-class="border-none" hide-footer>
       <Register @login="$bvDropdown.show('account-dropdown')" submit-url="/account/register" :regError="$attrs.regError">
              <input type="hidden" name="_token" :value="csrf">
            </Register>
    </b-modal>
  </header>
</template>

<style scoped>
  .cart-name-cell{
    max-width: 250px;
  }
  #pb-menu-layout-1 .navbar-brand-box {
    overflow: hidden;
    max-height: 70px;
  }
  .dropdown-menu.bg-dark .dropdown-item:hover, .dropdown-menu.bg-dark .dropdown-item:focus{
    background-color: #000;
  }
  .navbar-header.bg-dark .nav-item:hover{
    background-color: #000;
  }
  .border-top.bg-dark{
    border-color: #444 !important;
  }
  ul.bg-dark ~ .card{
    background-color: #343a40 !important;
    color: #ffffff !important;
  }
  .dropdown-menu.dropright{
    right: -100%;
    top: -8px !important;
  }
  .arrow-right:after{
    border-color: initial;
    border-style: solid;
    border-width: 0 0 1px 1px;
    content: "";
    height: 0.4em;
    display: inline-block;
    right: 5px;
    top: 50%;
    margin-left: 10px;
    transform: rotate(-135deg) translateY(-50%);
    transform-origin: top;
    transition: all 0.3s ease-out;
    width: 0.4em;
  }
  .dropdown-item-white{
    color: #fff !important;
  }
  .m-w-100{
    min-width: 100%;
  }
  .m-w-100 .dropdown-menu.dropright{
    min-width: 100%;
  }
</style>